<template>

	<v-container fluid class="container-full-bg-gray">

		<v-dialog v-model="showDialogActivateTrialFacturaeClient" max-width="540">
			<v-card>
				<v-card-title>Activar trial Factura Electrónica</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-container>
						<p>Selecciona la empresa para activar la prueba de 7 días de factura electrónica</p>
						<v-autocomplete autocomplete="off" label="Empresa" v-model="companyActivateTrialClient"
							:items="get_companydbs" item-text="name" return-object hide-details></v-autocomplete>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-btn @click="activateTrialFacturaeClient()">Activar Trial</v-btn>
					<v-btn @click="showDialogActivateTrialFacturaeClient = false">Cancelar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<DialogLink name="Adhesión a la prestación de servicios" :show_contract="show_contract" @hide="hideContract()">
			<LegalContract :params="{
				postal_address: userData.postal_address,
				province: userData.province,
				bussnies_id: userData.bussnies_id,
				business_name: userData.business_name,
				name: userData.name,
				docs_num: docs_num,
				price: price,
				date: firm_date
			}" kind="contract" api="get_user_legal_contract" />
		</DialogLink>

		<DialogLink name="Política de Privacidad" :show_contract="show_policy_privacity" @hide="hidePolicyPrivacity()">
			<LegalContract kind="privacy_policy" api="get_user_legal_contract" />
		</DialogLink>

		<DialogLink name="Tratamiento de Datos" :show_contract="show_data_treatment" @hide="hideDataTreatment()">
			<LegalContract :params="{
				business_name: userData.business_name,
				name: userData.name
			}" kind="data_treatment" api="get_user_legal_contract" />
		</DialogLink>

		<app-modal-prompt v-model="changePassword.showDialog"
			:is-confirm-button-disabled="!(changePassword.form.oldpassword && changePassword.form.password1 && changePassword.form.password2)"
			@cancel="resetChangePassword" @confirm="confirmChangePassword"
			:confirmBtnText="changePassword.confirmBtnText" :loading="changePassword.loading">
			<template #title>
				Cambiar contraseña
			</template>
			<app-modal-row>
				<app-modal-col cols="6" class="pr-2">
					<app-date-picker aucomplete="off" v-model="changePassword.form.min_date"
						label="Fecha mínima de las facturas (dd/mm/yyyy)"></app-date-picker>
				</app-modal-col>
				<app-modal-col cols="6" class="pl-2">
					<app-date-picker aucomplete="off" v-model="changePassword.form.max_date"
						label="Fecha máxima de las facturas (dd/mm/yyyy)"></app-date-picker>
				</app-modal-col>
			</app-modal-row>

			<app-modal-row>
				<app-modal-col cols="12">
					<v-form ref="form">
						<app-text-field :type="changePassword.form.showOldPassword ? 'text' : 'password'"
							label="Contraseña actual" prepend-icon="mdi-lock"
							:append-icon="changePassword.form.showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
							v-model="changePassword.form.oldpassword"
							@click:append="changePassword.form.showOldPassword = !changePassword.form.showOldPassword"
							v-on:keyup.enter="confirmChangePassword"
							:rules="[changePassword.validationRules.required, changePassword.validationRules.notBlankSpace]" />
						<app-text-field :type="changePassword.form.showPassword1 ? 'text' : 'password'"
							label="Nueva contraseña" prepend-icon="mdi-lock"
							:append-icon="changePassword.form.showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
							v-model="changePassword.form.password1"
							@click:append="changePassword.form.showPassword1 = !changePassword.form.showPassword1"
							v-on:keyup.enter="confirmChangePassword"
							:rules="[changePassword.validationRules.required, changePassword.validationRules.passMinLength, changePassword.validationRules.notBlankSpace]" />
						<app-text-field :type="changePassword.form.showPassword2 ? 'text' : 'password'"
							label="Repita la nueva contraseña" prepend-icon="mdi-lock"
							:append-icon="changePassword.form.showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
							v-model="changePassword.form.password2"
							@click:append="changePassword.form.showPassword2 = !changePassword.form.showPassword2"
							v-on:keyup.enter="confirmChangePassword"
							:rules="[changePassword.validationRules.required, changePassword.validationRules.notBlankSpace, changePassword.validationRules.passMinLength, changePassword.validationRules.passIsEqualToPass1]" />
						<p v-if="changePassword.error" class="red--text">{{ changePassword.error }}</p>
					</v-form>
				</app-modal-col>
			</app-modal-row>
		</app-modal-prompt>

		<app-modal-prompt v-model="sendDocsDialog" :loading="sendDocsLoading" @confirm="confirmSendDocs()"
			@cancel="cancelSendDocs()">
			<template #title>
				Traspasar Documentos
			</template>
			<app-modal-container>
				<v-form ref="sendDocsDialogForm">
					<app-modal-row>
						<app-modal-col cols="12">
							<app-autocomplete label="Destinatario documentos" v-model="modal_send_docs.receiver_user"
								:items="receiverDocsUsers" item-value="id" item-text="username"
								:rules="[validationRules.required]" :clearable="true">
							</app-autocomplete>
						</app-modal-col>
						<app-modal-col cols="12">
							<app-text-field autocomplete="off" label="Número documentos"
								v-model="modal_send_docs.num_docs"
								:rules="[validationRules.required, validationRules.greaterThanZero, validationRules.limitDocsNum]"
								type="number" />
						</app-modal-col>
					</app-modal-row>
				</v-form>
			</app-modal-container>
		</app-modal-prompt>

		<app-modal-prompt v-model="modal_create_concession.dialog" @confirm="confirmCreateConcession"
			@cancel="cancelCreateConcession">
			<template #title>
				Crear Concesión
			</template>
			<app-modal-container>
				<v-form ref="createConcessionForm">
					<app-modal-row>
						<app-modal-col cols="12">
							<app-text-field autocomplete="off" label="Número de documentos para la concesión"
								v-model="modal_create_concession.concession_number"
								:rules="[validationRules.required, validationRules.greaterThanZero]" type="number"
								min="0" />
						</app-modal-col>
						<app-modal-col cols="12">
							<app-text-field autocomplete="off" label="Motivo" v-model="modal_create_concession.reason"
								:rules="[validationRules.required]" />
						</app-modal-col>
					</app-modal-row>
				</v-form>
			</app-modal-container>
		</app-modal-prompt>

		<app-modal-prompt v-model="modal_change_end_date.dialog" @confirm="confirmChangeEndDate"
			@cancel="cancelChangeEndDate">
			<template #title>
				Cambiar fecha final de contrato
			</template>
			<app-modal-container>
				<v-form ref="changeEndDateForm">
					<app-modal-row>
						<app-modal-col cols="12" v-if="modal_change_end_date.error">
							<v-alert type="error" dense>
								{{ modal_change_end_date.error }}
							</v-alert>
						</app-modal-col>
						<app-modal-col cols="12">
							<app-text-field
								autocomplete="off"
								label="ID del contrato"
								v-model="modal_change_end_date.contract_id"
								:rules="[validationRules.required]"
								type="number"
							/>
						</app-modal-col>
						<app-modal-col cols="12">
							<app-text-field
								autocomplete="off"
								label="Nueva fecha final"
								v-model="modal_change_end_date.end_date"
								:rules="[validationRules.required]"
								type="date"
							/>
						</app-modal-col>
						<app-modal-col cols="12">
							<app-text-field
								autocomplete="off"
								label="Motivo"
								v-model="modal_change_end_date.reason"
								:rules="[validationRules.required]"
							/>
						</app-modal-col>
					</app-modal-row>
				</v-form>
			</app-modal-container>
		</app-modal-prompt>

		<app-modal-prompt v-model="modal_extend_trial_docs.dialog" @confirm="confirmExtendTrialDocs"
			@cancel="cancelExtendTrialDocs">
			<template #title>
				Añadir más créditos de prueba
			</template>
			<app-modal-container>
				<v-form ref="extendTrialDocsForm">
					<app-modal-row>
						<app-modal-col cols="12">
							<!-- elección tipo -->
							<v-btn-toggle v-model="modal_extend_trial_docs.contract_kind" mandatory class="mb-2">
								<v-btn value="documents" :disabled="!canExtendDocuments">
									Documentos
								</v-btn>
								<v-btn value="banks" :disabled="!canExtendBanks">
									Bancos
								</v-btn>
							</v-btn-toggle>
							<!-- mensajes si no puede añadir -->
							<div v-if="!canExtendDocuments" class="text-caption grey--text">
								{{ disabledDocumentsMessage }}
							</div>
							<div v-if="!canExtendBanks" class="text-caption grey--text">
								{{ disabledBanksMessage }}
							</div>
						</app-modal-col>
						<!-- añadición de créditos con sus comprobaciones -->
						<app-modal-col cols="12">
							<app-text-field 
								autocomplete="off" 
								:label="extendTrialCreditsLabel"
								v-model="modal_extend_trial_docs.extra_credits"
								:rules="[
									validationRules.required, 
									modal_extend_trial_docs.validationRules.notZero, 
									modal_extend_trial_docs.validationRules.maxTrialLimit, 
									modal_extend_trial_docs.validationRules.notNegativeResult
								]" 
								type="number"
								min="-100" max="100" 
							/>
						</app-modal-col>
						<!-- resultado esperado -->
						<app-modal-col cols="12" v-if="currentTrialLimit !== null && modal_extend_trial_docs.extra_credits">
							<div class="text-body-1 mb-2">
								<strong>{{ currentTrialLimit }}</strong> + <strong>{{ modal_extend_trial_docs.extra_credits }}</strong> = <strong>{{ newTrialLimit }}</strong> {{ trialCreditsUnit }}
							</div>
						</app-modal-col>
						<!-- escritura de motivo con mensaje formateado -->
						<app-modal-col cols="12">
							<app-text-field autocomplete="off" label="Motivo" v-model="modal_extend_trial_docs.reason"
								:rules="[validationRules.required]" />
						</app-modal-col>
					</app-modal-row>
				</v-form>
			</app-modal-container>
		</app-modal-prompt>

		<app-modal-prompt v-model="modal_add_note.dialog" @confirm="confirmAddNote"
			@cancel="cancelAddNote">
			<template #title>
				Añadir nota al contrato
			</template>
			<app-modal-container>
				<v-form ref="addNoteForm">
					<app-modal-row>
						<app-modal-col cols="12" v-if="modal_add_note.error">
							<v-alert type="error" dense>
								{{ modal_add_note.error }}
							</v-alert>
						</app-modal-col>
						<app-modal-col cols="12">
							<app-text-field autocomplete="off" label="ID del contrato" v-model="modal_add_note.contract_id"
								:rules="[validationRules.required, validationRules.greaterThanZero]" type="number"
								min="1" />
						</app-modal-col>
						<app-modal-col cols="12">
							<app-text-field autocomplete="off" label="Nota" v-model="modal_add_note.reason"
								:rules="[validationRules.required]" />
						</app-modal-col>
					</app-modal-row>
				</v-form>
			</app-modal-container>
		</app-modal-prompt>

		<app-modal-prompt v-model="modal_change_name.dialog" @confirm="confirmChangeName"
			@cancel="cancelChangeName">
			<template #title>
				Cambiar nombre del contrato
			</template>
			<app-modal-container>
				<v-form ref="changeNameForm">
					<app-modal-row>
						<app-modal-col cols="12" v-if="modal_change_name.error">
							<v-alert type="error" dense>
								{{ modal_change_name.error }}
							</v-alert>
						</app-modal-col>
						<app-modal-col cols="12">
							<app-text-field autocomplete="off" label="ID del contrato" v-model="modal_change_name.contract_id"
								:rules="[validationRules.required, validationRules.greaterThanZero]" type="number"
								min="1" />
						</app-modal-col>
						<app-modal-col cols="12">
							<app-text-field autocomplete="off" label="Nuevo nombre" v-model="modal_change_name.new_name"
								:rules="[validationRules.required]" />
						</app-modal-col>
						<app-modal-col cols="12">
							<app-text-field autocomplete="off" label="Motivo" v-model="modal_change_name.reason"
								:rules="[validationRules.required]" />
						</app-modal-col>
					</app-modal-row>
				</v-form>
			</app-modal-container>
		</app-modal-prompt>

		<app-modal-prompt v-model="invoicesList.showDialog" :confirmBtnText="invoicesList.confirmBtnText"
			:showCancelBtn="false" @confirm="confirminvoicesList">
			<template #title>
				Facturas
			</template>
			<app-modal-container class="text-center">
				<app-modal-row v-for="pdf in invoicesList.pdfs">
					<app-modal-col cols="12">
						<span v-html="pdf"></span>
					</app-modal-col>
				</app-modal-row>
			</app-modal-container>
		</app-modal-prompt>
		<!-- sergiiiiiiiiiiiiiiiiiiii -->
		<!-- <app-modal-prompt 
			v-if="false" 
			v-model="addPaidUsers.showDialog" 
			:loading="addPaidUsers.loading" 
			:width="'40%'"
			@cancel="cancelAddPaidUsers" 
			@confirm="confirmAddPaidUsers"
		>
			<template #title>
				Contratar usuarios adicionales
			</template>
			<app-modal-container class="extra-users-modal">
				<app-modal-row>
					<app-modal-col cols="12" class="mb-4">
						<v-simple-table dense>
							<template v-slot:default>
								<tbody>
									<tr>
										<td>Usuarios incluidos en el plan actual</td>
										<td class="font-weight-bold text-center pl-5">{{ addPaidUsers.extra_users_data.limit_users }}</td>
									</tr>
									<tr v-if="addPaidUsers.extra_users_data.paid_extra_users > 0">
										<td>Usuarios ya contratados</td>
										<td class="font-weight-bold text-center pl-5">{{ addPaidUsers.extra_users_data.paid_extra_users }}</td>
									</tr>
									<tr>
										<td>Usuarios activos</td>
										<td class="font-weight-bold text-center pl-5">{{ addPaidUsers.extra_users_data.users_num }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</app-modal-col>
				</app-modal-row>
				<hr />
				<app-modal-row class="px-4">
					<app-modal-col cols="9">
						<p class="ma-0 pa-0 mt-4">Coste por usuario adicional:</p>
					</app-modal-col>
					<app-modal-col cols="3">
						<p class="ma-0 pa-0 mt-4 text-right">{{ addPaidUsers.amount !== null ? addPaidUsers.amount.toFixed(2) : 'error' }} € </p>
					</app-modal-col>
				</app-modal-row>
				<app-modal-row class="px-4 d-flex justify-content-center">
					<app-modal-col cols="10" class="d-flex align-items-center">
						<p class="d-flex align-items-center mr-5">Usuarios adicionales:</p>
					</app-modal-col>
					<app-modal-col cols="2" class="d-flex align-items-center">
						<v-form ref="form">
							<app-text-field type="number"
								v-model="addPaidUsers.form.users_num"
								:min="1"
								:rules="[...Object.values(addPaidUsers.form.validationRules)]" 
								@input="value => addPaidUsers.form.users_num = Math.max(1, value)"
								dense outlined class="mini-input pa-0 ma-0"/>
						</v-form>
					</app-modal-col>
				</app-modal-row>
				<hr />
				<app-modal-row class="px-4 pt-4">
					<app-modal-col cols="8">
					</app-modal-col>
					<app-modal-col cols="4" class="text-right">
						<p class="my-0"><b class="mr-5">TOTAL </b><b class="total-price">{{ Math.max(0, Math.round((addPaidUsers.amount * addPaidUsers.form.users_num) * 100) / 100) }} €</b></p>
						<p>(sin IVA)</p>
					</app-modal-col>
				</app-modal-row>
				<app-modal-row class="px-4">
					<app-modal-col cols="12">
						<p class="mb-2"> Cuenta de Inmatic: </p>
						<span class="font-weight-bold my-4">BANCO SABADELL IBAN: ES04 0081 0400 1100 0123 0926</span>
					</app-modal-col>
					<app-modal-col cols="12">
						<v-form ref="paymentFileForm">
							<v-file-input label="Adjuntar justificante de pago"
								v-model="addPaidUsers.paymentFileForm.payment_file" class="pt-2"
								prepend-icon="mdi-paperclip" accept=".pdf" :loading="addPaidUsers.loading"
								:rules="[...Object.values(addPaidUsers.paymentFileForm.validationRules)]"
								:error="addPaidUsers.paymentFileForm.error"
								:error-messages="addPaidUsers.paymentFileForm.errorMsg" 
								:class="'pb-0'" outlined dense></v-file-input>
							<p class="mb-2 ml-5 pl-2 small-letter">* Una vez adjuntado el justificante, se generará la factura correspondiente.</p>
						</v-form>
					</app-modal-col>
				</app-modal-row>
			</app-modal-container>
		</app-modal-prompt> -->
		<!-- <app-modal-prompt v-model="additionalServices.showDialog" :width="'50%'"
			:persistent="additionalServices.persistent" :loading="additionalServices.loading"
			:key="additionalServices.key" @confirm="confirmAdditionalServicesUploadFfile"
			@cancel="cancelAdditionalServicesUploadFfile">
			<template #title>
				Subir justificante de pago
			</template>
			<app-modal-container>
				<app-modal-row>
					<app-modal-col cols="12">
						<p class="mt-1">El importe a pagar es de {{ additionalServices.amount }}€ (impuestos incluidos).
						</p>
					</app-modal-col>
					<app-modal-col cols="12">
						<p class="mb-2"> Cuenta de Inmatic: <span class="font-weight-bold my-4">BANCO SABADELL IBAN:
								ES04 0081 0400 1100 0123 0926</span></p>
					</app-modal-col>
				</app-modal-row>
				<app-modal-row>
					<app-modal-col cols="10" class="mx-auto">
						<v-form ref="form">
							<v-file-input label="Adjuntar justificante de pago"
								v-model="additionalServices.paymentFileForm.payment_file" class="py-2"
								prepend-icon="mdi-paperclip" accept=".pdf" :loading="additionalServices.loading"
								:rules="[...Object.values(additionalServices.paymentFileForm.validationRules)]"
								:error="additionalServices.paymentFileForm.error"
								:error-messages="additionalServices.paymentFileForm.errorMsg" outlined
								dense></v-file-input>
						</v-form>
					</app-modal-col>
					<app-modal-col cols="12">
						<p class="mb-2"><i>* Una vez adjuntado el justificante de pago, se generará la factura
								correspondiente.</i></p>
					</app-modal-col>
				</app-modal-row>
			</app-modal-container>
		</app-modal-prompt> -->

		<app-modal-prompt 
					v-model="refund.showDialog" 
					:loading="refund.loading" 
					@confirm="confirmCreaterefund"
					@cancel="cancelCreaterefund"
					:persistent="refund.persistent"
					:key="'refund'+refund.key">
			<template #title>
				Realizar abono
			</template>
				<app-modal-container>
						<v-form ref="form">
							<app-modal-row>
								<app-modal-col cols="1">
									<v-icon :class="'primary--text'" style="font-size: 40px;">mdi-alert-outline</v-icon>
								</app-modal-col>
								<app-modal-col cols="11" :class="'pl-4'">
									<p>A tener en cuenta que el total de la factura puede no corresponder al total del precio del contrato a abonar.</p>
								</app-modal-col>
							</app-modal-row>
							<app-modal-row>
								<app-modal-col cols="12">
									<p>Contrato restante: {{ refund.remainingContract }} %</p>
								</app-modal-col>
							</app-modal-row>
							<app-modal-row>
								<app-modal-col cols="12" v-if="refund.percentage">
									<p>Porcentaje abonado: {{ refund.percentage }} %</p>
								</app-modal-col>
							</app-modal-row>
							<app-modal-row>
								<app-modal-col cols="12">
									<app-text-field
										label="Porcentaje del abono"
										:append-icon="'mdi-percent-outline'"
										v-model="refund.form.percentage"
										:rules="[
											refund.validationRules.required, 
											refund.validationRules.isTypeNumber, 
											refund.validationRules.greaterThanRemainingPercentage, 
											refund.validationRules.lessThanRefundedPercentage, 
											refund.validationRules.maxTwoDecimals]"
										/>
								</app-modal-col>
							</app-modal-row>
						</v-form>
				</app-modal-container>
		</app-modal-prompt>
		<app-modal-prompt v-model="updateUserTaxData.showDialog" :width="'60%'" :loading="updateUserTaxData.loading"
			@confirm="confirmUpdateUserTaxData" @cancel="cancelUpdateUserTaxData">
			<template #title>
				Actualizar datos fiscales
			</template>
			<app-modal-container>
				<v-form ref="form">
					<app-modal-row>
						<app-modal-col cols="12">
							<p>Actualiza los datos fiscales del cliente.</p>
						</app-modal-col>
					</app-modal-row>
					<app-modal-row>
						<app-modal-col cols="7">
							<app-text-field label="Razón Social" v-model="updateUserTaxData.businessData.name"
								:rules="[updateUserTaxData.validationRules.required]" />
						</app-modal-col>
						<app-modal-col cols="5" class="pl-3">
							<app-text-field label="NIF / DNI" v-model="updateUserTaxData.businessData.id"
								:rules="[updateUserTaxData.validationRules.required, updateUserTaxData.validationRules.validNifOrCif]" />
						</app-modal-col>
					</app-modal-row>
					<app-modal-row>
						<app-modal-col cols="6">
							<app-text-field label="Dirección" v-model="updateUserTaxData.businessData.postalAddress"
								:rules="[updateUserTaxData.validationRules.required]" />
						</app-modal-col>
						<app-modal-col cols="3" class="px-3">
							<app-text-field label="Provincia" v-model="updateUserTaxData.businessData.province"
								:rules="[updateUserTaxData.validationRules.required]" />
						</app-modal-col>
						<app-modal-col cols="3">
							<app-text-field label="CP" v-model="updateUserTaxData.businessData.postCode"
								:rules="[updateUserTaxData.validationRules.required]" />
						</app-modal-col>
					</app-modal-row>
				</v-form>
			</app-modal-container>
		</app-modal-prompt>

		<app-modal-prompt v-model="sendTransactionsDialog" :loading="sendTransactionsLoading"
			@confirm="confirmSendTransactions()" @cancel="cancelSendTransactions()">
			<template #title>
				Traspasar Transacciones
			</template>
			<app-modal-container>
				<v-form ref="sendTransactionsDialogForm">
					<app-modal-row>
						<app-modal-col cols="12">
							<app-autocomplete label="Destinatario transacciones"
								v-model="modal_send_transactions.receiver_user" :items="receiverDocsUsers"
								item-value="id" item-text="username" :rules="[validationRules.required]"
								:clearable="true">
							</app-autocomplete>
						</app-modal-col>
						<app-modal-col cols="12">
							<app-text-field autocomplete="off" label="Número transacciones"
								v-model="modal_send_transactions.num_transactions"
								:rules="[validationRules.required, validationRules.greaterThanZero, validationRules.limitTransactionsNum]"
								type="number" />
						</app-modal-col>
					</app-modal-row>
				</v-form>
			</app-modal-container>
		</app-modal-prompt>

		<v-snackbar v-model="snackbar.isVisible" :color="snackbar.color" :timeout="snackbar.timeout">
			{{ snackbar.text }}
		</v-snackbar>



		<app-page-card>
			<template #header>Mis datos</template>
			<template #header-actions v-if="got_feature('feature_show_worker_version')">
				<div class="small-grey-text">Versión del conector: {{ worker_version }}</div>
			</template>

			<app-container fluid>
				<app-row contains-input-fields>
					<app-col contains-input-fields cols="4" lg="4">
						<app-text-field label="Nombre de usuario" type="text" :readonly="true"
							v-model="profile.form.username" />
					</app-col>
					<app-col contains-input-fields cols="2" lg="2">
						<app-text-field label="Rol" type="text" :readonly="true" v-model="profile.form.user_role" />
					</app-col>
					<app-col cols="2" lg="2">
						<app-btn height="60px" block @click="showChangePassword" class="btn-profile" outlined>
							<v-icon>mdi-lock-reset</v-icon>
							Cambiar Contraseña
						</app-btn>
					</app-col>
					<app-col cols="2" lg="2" v-if="userData && !got_feature('feature_cliente_glasof') &&
						(
							['docunecta', 'glasof', 'gestoriamoro'].indexOf(userData.sender_docs_user_distributor_code) === -1
							|| userData.white_brand_code !== 'oxigen'
						)">
						<div class="switch_box rounded-lg">
							<v-switch class="switch" v-model="receive_newsletter" block outlined hide-details
								:loading="receive_newsletter_loading" @click="update_receive_newsletter_status">
								<template v-slot:label>
									<span class="switch__label">Recibir novedades</span>
								</template>
							</v-switch>
						</div>
					</app-col>
				</app-row>
				<span v-if="showAllFields()">
					<app-row contains-input-fields>
						<app-col contains-input-fields has-input-fields-above cols="4" lg="4">
							<app-text-field label="Razón Social" type="text" :readonly="true"
								v-model="profile.form.business_name" />
						</app-col>
						<app-col contains-input-fields has-input-fields-above cols="4" lg="4">
							<app-text-field label="NIF/NIE" type="text" :readonly="true"
								v-model="profile.form.bussnies_id" />
						</app-col>
						<app-col has-input-fields-above cols="2" lg="2">
							<app-btn height="60px" block v-if="showContractBtn()" @click="showContract"
								class="btn-profile" outlined>
								<v-icon>mdi-file-document-outline</v-icon>
								Ir al contrato
							</app-btn>
						</app-col>
					</app-row>
					<app-row contains-input-fields>
						<app-col contains-input-fields has-input-fields-above cols="4" lg="4">
							<app-text-field label="Dirección Postal" type="text" :readonly="true"
								v-model="profile.form.postal_address" />
						</app-col>
						<app-col contains-input-fields has-input-fields-above cols="3" lg="3">
							<app-text-field label="Población" type="text" :readonly="true"
								v-model="profile.form.province" />
						</app-col>
						<app-col contains-input-fields has-input-fields-above cols="1" lg="1">
							<app-text-field label="CP" type="text" :readonly="true" v-model="profile.form.post_code" />
						</app-col>
						<app-col cols="2" lg="2" has-input-fields-above>
							<app-btn height="60px" block v-if="showPolicyPrivacityBtn()" @click="showPolicyPrivacity"
								class="btn-profile" outlined>
								<v-icon>mdi-file-account-outline</v-icon>
								Política de privacidad
							</app-btn>
						</app-col>
					</app-row>
					<app-row contains-input-fields>
						<app-col has-input-fields-above contains-input-fields cols="4" lg="4">
							<app-text-field label="Nombre Completo del Representante" type="text" :readonly="true"
								v-model="profile.form.name" />
						</app-col>
						<app-col has-input-fields-above contains-input-fields cols="4" lg="4">
							<app-text-field label="NIF/NIE del Representante" type="text" :readonly="true"
								v-model="profile.form.dni" />
						</app-col>
						<app-col has-input-fields-above cols="2" lg="2">
							<app-btn height="60px" block v-if="showDataTreatmentBtn()" @click="showDataTreatment"
								class="btn-profile" outlined>
								<v-icon>mdi-folder-edit-outline</v-icon>
								Tratamiento de Datos
							</app-btn>
						</app-col>
					</app-row>
					<app-row contains-input-fields>
						<app-col contains-input-fields has-input-fields-above cols="4" lg="4">
							<app-text-field label="Email" type="text" :readonly="true" v-model="profile.form.email" />
						</app-col>
						<app-col v-if="showAllFields()" contains-input-fields has-input-fields-above cols="4" lg="4">
							<app-text-field label="Teléfono" type="text" :readonly="true"
								v-model="profile.form.phone" />
						</app-col>
						<app-col has-input-fields-above cols="2" lg="2" v-if="!got_feature('feature_cliente_glasof')">
							<app-btn 
								height="60px"
								block
								@click="PaymentInstallation"
								class="btn-profile" 
								outlined
								:loading="screen_data_2.payment_popup.showed"
							>
								<v-icon>mdi-wrench-outline</v-icon>
								Solicitar instalación
							</app-btn>

							<PaymentInstallationPopup 
								:show_payment_message="screen_data_2.payment_popup.showed"
								:screen_data_2="screen_data_2.payment_popup"
								@close-message="close"
							/>
						</app-col>
					</app-row>
				</span>

				<app-row contains-input-fields>
					<app-col v-if="got_feature('feature_show_promotional_code') && promotional_code"
						contains-input-fields has-input-fields-above cols="2" lg="3">
						<app-text-field label="Código Plan Amigo" type="text" :readonly="true"
							v-model="promotional_code.code" />
					</app-col>
				</app-row>
				<app-row contains-input-fields>
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<app-text-field label="Notas de Instalación" type="text" :readonly="true"
							v-model="profile.form.installation_notes" />
					</app-col>
				</app-row>
				<app-btn class="ml-2" outlined v-if="userData.can_view_e_invoice && !permission.is_employee && !permission.is_owner" @click="openDialogActivateTrialFacturaeClient()">Activar Trial Factura Electrónica</app-btn>
				<v-row v-if="((!permission.is_employee && !permission.is_owner) && userData.can_view_e_invoice) || (permission.is_customer && userData.can_view_working_hours && hasEverHadWorkingHoursContract)">
					<v-col cols="8" lg="8">
						<v-card primary outlined class="pa-2 ml-2">
							<p class="ml-2 font-weight-bold">Datos fiscales para contratar servicios</p>
							<v-form ref="updateProfileClientForm">
								<app-row contains-input-fields>
									<app-col contains-input-fields has-input-fields-above cols="6" lg="6">
										<app-text-field label="Razón Social" type="text"
											v-model="profileClientUpdate.business_name"
											:rules="[validationRules.required]" />
									</app-col>
									<app-col contains-input-fields has-input-fields-above cols="6" lg="6">
										<app-text-field label="NIF/NIE" type="text"
											v-model="profileClientUpdate.bussnies_id"
											:rules="[validationRules.required]" />
									</app-col>
								</app-row>
								<app-row contains-input-fields>
									<app-col contains-input-fields has-input-fields-above cols="6" lg="6">
										<app-text-field label="Dirección Postal" type="text"
											v-model="profileClientUpdate.postal_address"
											:rules="[validationRules.required]" />
									</app-col>
									<app-col contains-input-fields has-input-fields-above cols="3" lg="3">
										<app-text-field label="Población" type="text"
											v-model="profileClientUpdate.province"
											:rules="[validationRules.required]" />
									</app-col>
									<app-col contains-input-fields has-input-fields-above cols="3" lg="3">
										<app-text-field label="CP" type="text" v-model="profileClientUpdate.post_code"
											:rules="[validationRules.required]" />
									</app-col>
								</app-row>
							</v-form>
							<app-row>
								<app-btn class="ml-2" :outlined="isTaxDataFilledAndSaved()" :loading="profileClientUpdateLoading"
									@click="confirmUpdateProfileClient()">Guardar</app-btn>

							<app-btn class="ml-2" :disabled="!isTaxDataFilled()" v-if="userData.can_view_e_invoice && !permission.is_employee" @click="openContractModal({ 'msg': 'Contratar factura electrónica', 'distributor': false, 'facturae_client': false, 'is_company_selector_visible': true, 'is_tax_data_filled': isTaxDataFilled()})">Contratar Factura Electrónica</app-btn>

							<app-btn class="ml-2" :disabled="!isTaxDataFilled()" v-if="userData.can_view_working_hours && (!permission.is_employee || permission.is_customer)" @click="openContractModal({ 'msg': 'Contratar control horario', 'distributor': false, 'facturae_client': false, 'working_hours_client': true, 'is_company_selector_visible': true, 'is_tax_data_filled': isTaxDataFilled(), 'can_show_document_services_and_banks': false})">Contratar Control Horario</app-btn>

						</app-row>					
					</v-card>
					</v-col>
				</v-row>

				<app-row contains-input-fields v-if="hasItemsEInvoiceContractsValue && available_space_information"
					class="pb-2">
					<app-col has-input-fields-above cols="8" lg="8">
						<v-label>Almacenamiento Factura Electrónica: {{ available_space_information.used_space }} de
							1GB</v-label>
						<v-progress-linear rounded :value="available_space_information.percent_used" color="var(--v-primary-base)"
							height="30">
							{{ available_space_information.percent_used }} %
						</v-progress-linear>
					</app-col>
					<app-col has-input-fields-above cols="12" sm="12" md="4" lg="4"
						v-if="hasItemsEInvoiceContractsValue">
						<v-btn class="mt-4" href="/responsible-declaration">
							Declaración Responsable<br>Antifraude
						</v-btn>
					</app-col>

				</app-row>
				<app-row v-if="showAllFields() && userData.distributor_code">
					<app-col cols="4">
						<v-btn
							@click="openContractModal({ 'msg': 'Selecciona un usuario y el plan que deseas contratar para él', 'distributor': true, 'facturae_client': false, 'is_company_selector_visible': false, 'is_tax_data_filled': isTaxDataFilled() })">
							Nuevo contrato a usuario
						</v-btn>
					</app-col>
					<app-col cols="8">
						<v-btn @click="descargar_inmaticLink" :loading="loadingDownloadExe">
							Copiar enlace de descarga de InmaticLink
						</v-btn>
					</app-col>
				</app-row>

				<!--<contract-popup v-if="showContractModal"></contract-popup>-->
				<app-row v-if="userData.session_user && userData.session_user.is_staff && i_am_loginas">
					<app-col cols="3" lg="3">
						<app-btn @click="openUpdateFiscalDataOnly">
							Modificar datos fiscales
						</app-btn>
					</app-col>
				</app-row>
				<app-col cols="2" lg="2" v-if="showContractServiceButton">
					<v-btn @click="openContractModal({'msg': 'Tu contrato ha expirado o ha excedido el número máximo de documentos.', 'distributor': false, 'facturae_client': false, 'is_company_selector_visible': false, 'is_tax_data_filled': false, 'can_show_document_services_and_banks': true})"
							:loading="modal_create_concession.loading"
							>
							Contratar servicio
					</v-btn>
				</app-col>
				<app-row v-if="(i_am_staff || i_am_loginas) && crearConcessionButtonVisibility">
					<app-col cols="2" lg="2">
						<v-btn @click="openModalCreateConcession"
								:loading="modal_create_concession.loading"
								>
								CREAR CONCESIÓN
						</v-btn>
					</app-col>
				</app-row>
				<app-row v-if="(i_am_staff || i_am_loginas)">
					<app-col cols="3" lg="3">
						<v-menu offset-y :close-on-scroll="true" attach>
							<template v-slot:activator="{ on, attrs }">
								<v-btn v-bind="attrs" v-on="on" color="primary" dark>
									ACCIONES DE CONTRATO
									<v-icon right color="primary">mdi-chevron-down</v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item
									@click="openModalExtendTrialDocs"
									:disabled="!extendTrialCreditsButtonVisibility || modal_extend_trial_docs.loading"
								>
									<v-list-item-title>
										Añadir más créditos de prueba
										<v-progress-circular
											v-if="modal_extend_trial_docs.loading"
											indeterminate
											size="16"
											width="2"
											class="ml-2"
										/>
									</v-list-item-title>
								</v-list-item>
								<v-list-item
									@click="openModalChangeEndDate"
								>
									<v-list-item-title>
										Cambiar Fecha Final de contrato
										<v-progress-circular
											v-if="modal_change_end_date.loading"
											indeterminate
											size="16"
											width="2"
											class="ml-2"
										/>
									</v-list-item-title>
								</v-list-item>
								<v-list-item
									@click="openModalAddNote"
									:disabled="modal_add_note.loading"
								>
									<v-list-item-title>
										Añadir nota
										<v-progress-circular
											v-if="modal_add_note.loading"
											indeterminate
											size="16"
											width="2"
											class="ml-2"
										/>
									</v-list-item-title>
								</v-list-item>
								<v-list-item
									@click="openModalChangeName"
									:disabled="modal_change_name.loading"
								>
									<v-list-item-title>
										Cambiar nombre
										<v-progress-circular
											v-if="modal_change_name.loading"
											indeterminate
											size="16"
											width="2"
											class="ml-2"
										/>
									</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</app-col>
				</app-row>
				<app-row v-if="showAllFields()">
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<app-simple-table-with-api3 ref="contractsTable" :headers="getContractHeaders"
							:table-ref-name="'contractsTable'"
							:url="'get_contracts/'" :action-btn-list="contractActionBtnList('documents')"
							:invoiceRegenerable="invoiceRegenerable"
							@click-col-action-btn="clickUserTableActionBtn"
							@click-col-invoice-list-btn="clickOpenModalInvoicesList"
							@click-col-add-paid-users="clickAddPaidUsers"></app-simple-table-with-api3>
					</app-col>
					<app-col cols="4" lg="4"  v-if="got_feature('feature_purchase_extra_users')">
					</app-col>
				</app-row>

				<app-row v-if="showAllFields() && hasItemsBanksContractsValue">
					<app-col>
						<br>
						<br>
						<b>
							Bancos
						</b>
					</app-col>
				</app-row>

				<app-row v-show="showAllFields() && hasItemsBanksContractsValue">
					<br>
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<app-simple-table-with-api2 ref="banksContractsTable" :headers="getBankContractsHeaders()"
							:url="'query'"
							:api_params="{ query: 'service.bank.deliveries', args: { org_id: userData.user } }"
							:invoiceRegenerable="invoiceRegenerable"
							@has-items="hasItemsBanksContracts"
							:table-ref-name="'banksContractsTable'"
							:action-btn-list="contractActionBtnList('banks')"
							@click-col-invoice-list-btn="clickOpenModalInvoicesList"
							@click-col-action-btn="clickUserTableActionBtn"
							@click-col-add-paid-users="clickAddPaidUsers">
						</app-simple-table-with-api2>
					</app-col>
				</app-row>

				<app-row
					v-if="showAllFields() && hasItemDocsContractsValue && userData.available_features && userData.available_features.feature_other_documents">
					<app-col>
						<br>
						<br>
						<b>
							Documentos (Créditos)
						</b>
					</app-col>
				</app-row>

				<app-row
					v-show="showAllFields() && hasItemDocsContractsValue && userData.available_features && userData.available_features.feature_other_documents">
					<br>
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<!-- <app-simple-table-with-api2 ref="docContractsTable" :headers="defaultDocsContractsHeaders"
							:url="'query'"
							:api_params="{ query: 'get.credit.contracts', args: { user_id: userData.id } }"
							@has-items="hasItemsDocsContracts">
						</app-simple-table-with-api2> -->
					</app-col>
				</app-row>

				<app-row v-if="showAllFields() && userData.distributor_code">
					<app-col>
						<br>
						<br>
						<b>
							Contratos Clientes Distribuidor Facturas
						</b>

					</app-col>
				</app-row>

				<app-row v-if="showAllFields() && userData.distributor_code">
					<br>
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<app-simple-table-with-api ref="distributorContractsTable"
							:headers="getInvoiceDistributorContractsHeaders()"
							:invoiceRegenerable="invoiceRegenerable"
							:table-ref-name="'distributorContractsTable'"
							@click-col-action-btn="clickUserTableActionBtn"
							:url="'get_contracts/?distributor_clients=true'"
							:use-client2="true">
						</app-simple-table-with-api>
					</app-col>
				</app-row>

				<app-row v-if="showAllFields() && hasItemsBanksContractsDTBValue && userData.distributor_code">
					<app-col>
						<br>
						<br>
						<b>
							Contratos Clientes Distribuidor Bancos
						</b>
					</app-col>
				</app-row>

				<app-row v-show="showAllFields() && hasItemsBanksContractsDTBValue && userData.distributor_code">
					<br>
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<!-- <app-simple-table-with-api2 ref="bankDistributorContractsTable"
							:headers="getBankDistributorContractsHeaders()" :url="'query'"
							:table-ref-name="'bankDistributorContractsTable'"
							:api_params="{ query: 'service.bank.deliveries', args: { distributor_clients: true, org_id: userData.user } }"
							@has-items="hasItemsBanksContractsDTB">
						</app-simple-table-with-api2> -->
					</app-col>
				</app-row>

				<!-- Tabla de Instalaciones -->
				<app-row v-if="showAllFields() && hasItemsInstallationsValue">
					<app-col>
						<br>
						<b>
							Instalaciones
						</b>
					</app-col>
				</app-row>
				<app-row v-show="showAllFields() && hasItemsInstallationsValue">
					<br>
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<app-simple-table-with-api2 
							ref="installationsTable" 
							:headers="getInstallationHeaders()"
							:url="'query'"
							:api_params="{ query: 'get.installations.query', args: { user_id: this.userData.id }, limit: 35 }" 
							@has-items="hasItemsInstallations"
							:table-ref-name="'installationsTable'"
							:action-btn-list="contractActionBtnList('installation')"
							:invoiceRegenerable="invoiceRegenerable"
							@click-col-action-btn="clickUserTableActionBtn"
						/>
					</app-col>
				</app-row>

				<!-- Tabla de Factura Electronica -->
				<app-row
					v-if="(showAllFields() && hasItemsEInvoiceContractsValue) || (permission.is_invited && hasItemsEInvoiceClientContractsValue && got_feature('feature_buy_facturae_for_client'))">
					<app-col>
						<br>
						<b>
							Factura Electrónica
						</b>
					</app-col>
				</app-row>
				<app-row v-show="showAllFields() && hasItemsEInvoiceContractsValue">
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<app-simple-table-with-api2
							ref="eInvoiceContractsTable" 
							:headers="geteInvoiceContractsHeaders()"
							:url="'query'"
							:api_params="{ query: 'get.envoice.contracts', args: { user_id: userData.user }, limit: 35 }"
							:table-ref-name="'eInvoiceContractsTable'"
							:action-btn-list="contractActionBtnList('eInvoice')"
							@has-items="hasItemsEInvoiceContracts"
							@get-items="itemsEInvoiceContracts"
							@click-col-action-btn="clickUserTableActionBtn"
							@click-col-invoice-list-btn="clickOpenModalInvoicesList"
							@click-col-add-paid-users="clickAddPaidUsers"
						/>
						<SelectEInvContractPopup v-if="screen_data_2.selectCompanyPopup.showed"
							:show_select_e_inv_popup="screen_data_2.selectCompanyPopup.showed"
							:screen_data_2="screen_data_2.selectCompanyPopup"
							@close-message="close"
						/>
					</app-col>
				</app-row>
				<!-- Cliente -->
				<app-row v-show="userData.can_view_e_invoice && permission.is_invited && hasItemsEInvoiceClientContractsValue && got_feature('feature_buy_facturae_for_client')">
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<app-simple-table-with-api2
							ref="eInvoiceClientContractsTable"
							:table-ref-name="'eInvoiceClientContractsTable'"
							:headers="eInvoiceClientContractsHeaders"
							:url="'query'"
							:api_params="{ query: 'get.envoice.contracts', args: { user_id: userData.user, client:true } }"
							@has-items="hasItemsEInvoiceClientContracts"
						/>
					</app-col>
				</app-row>
				<app-row class="mt-5 pl-2" v-if="showAllFields() && got_feature('feature_buy_facturae_for_client')">
					<v-btn
							@click="openContractModal({ 'msg': 'Selecciona un usuario cliente para contratarle la factura electrónica', 'distributor': false, 'facturae_client': true, 'is_company_selector_visible': false, 'is_tax_data_filled': isTaxDataFilled()})">
							Nuevo contrato eFactura a cliente
						</v-btn>
				</app-row>
				
				<!-- Tabla de Servicios Adicionales -->
				<app-row v-if="showAllFields() && hasItemsAdditionalServicesValue">
					<app-col>
						<br>
						<b>
							Servicios Adicionales
						</b>
					</app-col>
				</app-row>
				<app-row v-show="showAllFields() && hasItemsAdditionalServicesValue">
					<br>
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<app-simple-table-with-api2 
							ref="additionalServicesTable" 
							:headers="getAdditionalServicesHeaders()"
							:url="'query'"
							:api_params="{ query: 'get.additional.services.query', args: { user_id: this.userData.id }, limit: 35 }" 
							@has-items="hasItemsAdditionalServices"
							:table-ref-name="'additionalServicesTable'"
							:action-btn-list="contractActionBtnList('additionalServices')"
							:invoiceRegenerable="invoiceRegenerable"
							@click-col-action-btn="clickUserTableActionBtn"
							@click-upload-payment-file-btn="clickOpenModalUploadPaymentFile"
							@open-pay-charge-popup="openPayChargePopup"
						/>
					</app-col>
				</app-row>

				<!-- Tabla de Working Hours Services -->
				<app-row v-if="!got_feature('feature_hide_working_hours') && ((showAllFields() && hasItemsWorkingHoursValue) || (permission.is_invited && hasItemsWorkingHoursClientValue) || (showAllFields() && hasItemsWorkingHoursClientValue))">
					<app-col>
						<br>
						<b>
							Control Horario
						</b>
					</app-col>
				</app-row>
				<app-row v-show="!got_feature('feature_hide_working_hours') && showAllFields() && hasItemsWorkingHoursValue">
					<br>
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<app-simple-table-with-api2
							:key="workingHoursTableKey"
							ref="workingHoursTable"
							:headers="getWorkingHoursHeaders()"
							:url="'query'"
							:api_params="{ query: 'get.working.hours.services.query', args: { user_id: this.userData.id }, limit: 35 }"
							@has-items="hasItemsWorkingHours"
							@get-items="itemsWorkingHours"
							:table-ref-name="'workingHoursTable'"
							:action-btn-list="contractActionBtnList('workingHours')"
							:invoiceRegenerable="invoiceRegenerable"
							@click-col-action-btn="clickUserTableActionBtn"
							@click-col-add-paid-users="clickAddPaidUsers"
							@click-col-select-companies="openWorkingHoursOwnerPopup"/>
						<SelectCompanySimplePopup
							:show="showSimpleCompanyPopup"
							:companies="availableCompanies"
							@close="closeSimpleCompanyPopup"
							@save="saveSelectedCompany"
						/>
					</app-col>
				</app-row>
				<!-- Cliente -->
				<app-row v-show="!got_feature('feature_hide_working_hours') && permission.is_invited && hasItemsWorkingHoursClientValue">
					<app-col contains-input-fields has-input-fields-above cols="8" lg="8">
						<app-simple-table-with-api2
							ref="workingHoursClientTable"
							:table-ref-name="'workingHoursClientTable'"
							:headers="workingHoursClientHeaders"
							:url="'query'"
							:api_params="{ query: 'get.working.hours.services.query', args: { user_id: userData.user, client:true } }"
							@has-items="hasItemsWorkingHoursClient"
						/>
						<SelectWorkingHoursContractPopup v-if="screen_data_2.selectWorkingHoursPopup.showed"
							:show_select_working_hours_popup="screen_data_2.selectWorkingHoursPopup.showed"
							:screen_data_2="screen_data_2.selectWorkingHoursPopup"
							@close-message="closeWorkingHoursPopup"
						/>
					</app-col>
				</app-row>
			</app-container>
		</app-page-card>
	</v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mapFields } from 'vuex-map-fields';
import AppPageCard from '@/components/layout/AppPageCard.vue';
import AppContainer from '@/components/layout/AppContainer.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import DialogLink from "@/components/DialogLink";
import PolicyServices from "@/components/WelcomeSteps/PolicyServices";
import PolicyDialogLink from "@/components/WelcomeSteps/PolicyDialogLink.vue";
import PolicyPrivacity from "@/components/WelcomeSteps/PolicyPrivacity.vue";
import LegalContract from "@/components/WelcomeSteps/LegalContract";
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppSimpleTableWithApi from '@/components/layout/AppSimpleTableWithApi.vue';
import AppSimpleTableWithApi2 from '@/components/layout/AppSimpleTableWithApi2.vue';
import AppSimpleTableWithApi3 from '@/components/layout/AppSimpleTableWithApi3.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppAutocomplete from '../components/layout/AppAutocomplete.vue';
import SettingsCard from '@/components/settings/SettingsCard.vue';
import { sync_command_dispatcher, async_command_dispatcher, query_dispatcher, client } from "@/api/client";
import { ReceiverDocsUsersQuery } from '@/modules/revenue/app/ReceiverDocsUsersQuery';
import { SendDocsUserCommand } from "../modules/revenue/app/SendDocsUserCommand"
import { RegenerateInvoiceCommand } from "@/modules/revenue/app/RegenerateInvoiceCommand";
import { CreateConcessionCommand } from "@/modules/revenue/app/CreateConcessionCommand";
import { ChangeEndDateCommand } from "@/modules/revenue/app/ChangeEndDateCommand";
import { ExtendTrialDocsCommand } from "@/modules/revenue/app/ExtendTrialDocsCommand";
import { AddNoteToContractCommand } from "@/modules/revenue/app/AddNoteToContractCommand";
import { ChangeContractNameCommand } from "@/modules/revenue/app/ChangeContractNameCommand";
import { CheckContractExistsQuery } from "@/modules/revenue/app/CheckContractExistsQuery";
import { SendTransactionsUserCommand } from "../modules/revenue/app/SendTransactionsUserCommand"
import { ReferidoPromotionalCodeQuery } from '@/modules/revenue/app/ReferidoPromotionalCodeQuery';
import { ActivateFacturaeClientTrialCommand } from '@/modules/revenue/app/ActivateFacturaeClientTrialCommand';
import { UpdateUserInfo } from "@/modules/accounts/app/UpdateUserInfo";
import { UpdateFiscalDataUserCommand } from "@/modules/users/application/UpdateFiscalDataUserCommand";
import DataTableWithApi from '../components/DataTableWithApi.vue'
import { GetAvailableSpaceQuery } from '@/modules/facturae/app/get_available_e_invoice_space';
import App from "@/App.vue";
import { VuePaymentPopup } from "@/modules/revenue/infra/VuePaymentPopup";
import PaymentInstallationPopup from "@/modules/revenue/infra/PaymentInstallationPopup.vue";
import { VueSelectEInvContractPopup } from "@/modules/revenue/infra/VueSelectEInvContractPopup";
import SelectEInvContractPopup from "@/modules/revenue/infra/SelectEInvContractPopup.vue";
import { VueSelectWorkingHoursContractPopup } from "@/modules/revenue/infra/VueSelectWorkingHoursContractPopup";
import SelectWorkingHoursContractPopup from "@/modules/revenue/infra/SelectWorkingHoursContractPopup.vue";
import SelectCompanySimplePopup from "@/modules/revenue/infra/SelectCompanySimplePopup.vue";
import { APIInstallationsRepository } from "@/modules/revenue/infra/ApiInstallationRepository";
import { NewInstallationCommand } from "@/modules/revenue/app/NewInstallationCommand";
import { S3Repository } from '@/modules/shared/infra/S3Repository';
import awsconfig from '../aws-exports';
import { mapState } from "vuex";
import { APIServiceDeliveryRepository } from "@/modules/revenue/infra/ApiServiceDeliveryRepository";
import { SelectCompaniesSD } from "@/modules/revenue/app/SelectCompaniesSD";
import { APICompanyRepository } from "@/modules/revenue/infra/ApiCompanyRepository";
import { Company } from "@/modules/revenue/domain/Company";
import { ServiceDelivery } from "@/modules/revenue/domain/ServiceDelivery";
import { MemoryServiceDeliveryRepo } from "@/modules/revenue/infra/MemoryServiceDeliveryRepo";
import { API_regenerate_invoice_script } from "@/modules/revenue/infra/regenerateInvoiceLogic";
import { ConsequenceTemplate } from "@/modules/guidelines/domain/Guideline";
import {eInvoice_selections_chanded_handle_script} from '@/modules/revenue/infra/JT_DEL_20250528_ConcessionsLogic';
import { CreateRefundCommand } from "@/modules/revenue/app/CreateRefundCommand";
import { RegenerateInvoiceWithUpdatedTaxDataCommand } from "@/modules/revenue/app/RegenerateInvoiceWithUpdatedTaxDataCommand";
import { GetAdditionalServicesQuery } from '@/modules/revenue/app/GetAdditionalServicesQuery';
// import { InvoicePaidCustomChargeCommand } from '@/modules/revenue/app/InvoicePaidCustomChargeCommand';
// import { PurchaseExtraUsersCommand } from '@/modules/revenue/app/PurchaseExtraUsersCommand';
import { csc } from "mathjs";
import { Profile } from "@/modules/revenue/domain/Profile";
import { ProfileAllCommands } from "@/modules/revenue/app/ProfileAllCommands";
import { ApiProfile } from "@/modules/revenue/infra/ApiProfile";
import { canUserContractService } from "@/modules/user/domain/UserService";
import { GetOwnerWorkerVersionQuery } from '@/modules/users/application/GetOwnerWorkerVersionQuery';

export default {
	name: 'LoginPage',
	components: {
		AppPageCard,
		AppContainer,
		AppCol,
		AppRow,
		AppTextField,
		AppBtn,
		DialogLink,
		PolicyServices,
		PolicyDialogLink,
		PolicyPrivacity,
		LegalContract,
		AppModalPrompt,
		AppModalCol,
		AppModalRow,
		AppSimpleTableWithApi,
		AppSimpleTableWithApi2,
		AppSimpleTableWithApi3,
		AppModalContainer,
		AppAutocomplete,
		DataTableWithApi,
		PaymentInstallationPopup,
		SelectEInvContractPopup,
		SelectWorkingHoursContractPopup,
		SelectCompanySimplePopup,
	},
	data() {
		const profile = new Profile()
		return {
			component: null,
			screen_data: profile,
			actionModal: null,
			loading: false,
			changePassword: {
				form: {
					showOldPassword: false,
					showPassword1: false,
					showPassword2: false,
					oldpassword: '',
					password1: '',
					password2: '',
					error: '',
					loading: false,
					isPassChanged: false,
				},
				confirmBtnText: 'Cambiar',
				passMinLength: 8,
				textPassMinLength: 'Mínimo 8 carácteres',
				validationRules: {
					required: v => !!v || 'Campo obligatorio',
					passMinLength: v => v.length >= this.changePassword.passMinLength || this.changePassword.textPassMinLength,
					passIsEqualToPass1: v => v == this.changePassword.form.password1 || 'Las dos contraseñas deben ser iguales.',
					notBlankSpace: v => (!!v && !v.includes(' ')) || 'Campo con espacios en blanco',
				},
				showDialog: false,
				loading: false,
			},
			snackbar: {
				isVisible: false,
				text: '',
				color: '',
				timeout: 2000,
			},
			defaultContractsHeaders: [
				{
					text: 'Nombre',
					value: 'long_name',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Documentos',
					value: 'used_docs_num',
					sortable: false,
					align: 'start'
				},
				{
					text: 'Documentos iniciales',
					value: 'docs_num_ini',
					sortable: false,
					align: 'start'
				},
				{
					text: 'Fecha Creación',
					value: 'created',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Fecha Inicio',
					value: 'start_date',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Fecha Final',
					value: 'end_date',
					sortable: false,
					align: 'start',
				},
			],
			defaultBankContractsHeaders: [
				{
					text: 'Nombre',
					value: 'service',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Transacciones',
					value: 'transactions',
					sortable: false,
					align: 'start'
				},
				{
					text: 'Fecha Inicio',
					value: 'start_date',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Fecha Final',
					value: 'end_date',
					sortable: false,
					align: 'start',
				},
			],
			installationHeaders: [
				{
					text: 'Nombre',
					value: 'charge.organization.root_user',
					sortable: false,
					align: 'start',
					type: 'nested_property'
				},
				{
					text: 'Importe',
					value: "charge.amount",
					sortable: false,
					align: 'end',
					type: 'nested_property'
				},
				{
					text: 'Fecha Cargo',
					value: 'charge.payment_date',
					sortable: false,
					align: 'start',
					type: 'nested_property'
				},
				{
					text: 'Factura',
					value: 'charge.invoice_pdf_url',
					sortable: false,
					align: 'start',
					type: 'nested_property_link',
					link_text: 'Descargar'
				},
				{
					text: 'Justificante de Pago',
					value: 'charge.payment_file_url',
					sortable: false,
					align: 'start',
					type: 'nested_property_link',
					link_text: 'Descargar'

				},
			],
			additionalServicesHeaders: [
				{
					text: 'Concepto',
					value: 'invoice_concept',
					sortable: false,
					align: 'start',
					table: 'additional_services'
				},
				{
					text: 'Cantidad',
					value: "invoice_quantity",
					sortable: false,
					align: 'end',
				},
				{
					text: 'Importe (Imp. incl.)',
					value: "total_amount",
					sortable: false,
					align: 'end',
				},
				{
					text: 'Fecha Cargo',
					value: 'charge_date',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Factura',
					value: 'invoice_pdf_url',
					sortable: false,
					align: 'start',
					type: 'link',
					link_text: 'Descargar'
				},
				{
					text: 'Justificante de Pago',
					value: 'payment_file_url',
					sortable: false,
					align: 'start',
					type: 'link',
					link_text: 'Descargar',
					table: 'additional_services'
				},
				{
					text: 'Pagar cargo',
					value: 'pay_charge',
					sortable: false,
					align: 'center',
					button_icon: 'mdi-cash',
					button_text: 'Elije el método de pago'
				},
			],
			workingHoursHeaders: [
				{
					text: 'Nombre',
					value: 'service',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Empresa',
					value: 'organization_name',
					sortable: false,
					align: 'start',
					show_button_when_empty: true,
					button_icon: 'icon-select-company.svg',
					button_text: 'Configurar mis empresas',
					is_svg: true
				},
				{
					text: 'Fecha Inicio',
					value: 'start_date',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Fecha Final',
					value: 'end_date',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Factura',
					value: 'invoice_pdf',
					sortable: false,
					align: 'start',
					type: 'link',
					link_text: 'Descargar'
				},
			],
			eInvoiceContractsHeaders: [
				{
					text: 'Nombre',
					value: 'name',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Creditos',
					value: 'credits',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Fecha de inicio',
					value: "start_date",
					sortable: false,
					align: 'end',
				},
				{
					text: 'Fecha fin',
					value: 'end_date',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Factura',
					value: 'invoice_pdf',
					sortable: false,
					align: 'start',
					type: 'link',
					link_text: 'Descargar'
				},
				{
					text: 'Empresa',
					value: 'companies_display',
					sortable: false,
					align: 'start',
					type: 'html'
				},
				{
					text: 'Mis empresas',
					value: 'actions',
					sortable: false,
					align: 'center'
				}
			],
			workingHoursClientHeaders: [
				{
					text: 'Nombre',
					value: 'service',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Empresa',
					value: 'organization_name',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Fecha Inicio',
					value: 'start_date',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Fecha Final',
					value: 'end_date',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Factura',
					value: 'invoice_pdf',
					sortable: false,
					align: 'start',
					type: 'link',
					link_text: 'Descargar'
				},
			],
			eInvoiceClientContractsHeaders: [
				{
					text: 'Nombre',
					value: 'name',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Creditos',
					value: 'credits',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Fecha de inicio',
					value: "start_date",
					sortable: false,
					align: 'end',
				},
				{
					text: 'Fecha fin',
					value: 'end_date',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Factura',
					value: 'invoice_pdf',
					sortable: false,
					align: 'start',
					type: 'link',
					link_text: 'Descargar'
				},
			],
			defaultDocsContractsHeaders: [
				{
					text: 'Nombre',
					value: 'name',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Creditos',
					value: 'credits',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Fecha Inicio',
					value: 'start_date',
					sortable: false,
					align: 'start',
				},
				{
					text: 'Fecha Final',
					value: 'end_date',
					sortable: false,
					align: 'start',
				},
			],
			sendDocsDialog: false,
			sendDocsLoading: false,
			modal_create_concession: {
				concession_number: null,
				reason: null,
				selectedItem: {},
				dialog: false,
				loading: false
			},
			modal_extend_trial_docs: {
				extra_credits: null,
				reason: null,
				contract_kind: 'documents',
				selectedItem: {},
				dialog: false,
				loading: false,
				validationRules: {
					notZero: v => v != 0 || 'El número no puede ser 0.',
					notNegativeResult: v => this.newTrialLimit >= 0 || `El resultado no puede ser negativo (${this.currentTrialLimit} + (${v}) = ${this.newTrialLimit})`,
					maxTrialLimit: v => this.newTrialLimit <= 150 || `El total de créditos de prueba no puede superar 150 (${this.currentTrialLimit} + ${v} = ${this.newTrialLimit})`,
				},
			},
			modal_change_end_date:{
				loading: false,
				end_date: null,
				reason: null,
				contract_id: null,
				dialog: false,
				error: null,
			},
			modal_add_note: {
				contract_id: null,
				reason: null,
				selectedItem: {},
				dialog: false,
				loading: false,
				error: null
			},
			modal_change_name: {
				contract_id: null,
				new_name: null,
				reason: null,
				selectedItem: {},
				dialog: false,
				loading: false,
				error: null
			},
			invoicesList: {
				showDialog: false,
				loading: false,
				count: 0,
				confirmBtnText: 'Aceptar',
			},
			refund: {
				selectedItem: null,
				percentage: null,
				remainingContract: null,
				form: {
					percentage: "",
					error: '',
					loading: false,
				},
				validationRules: {
					required: v => !!v || 'Campo obligatorio',
					isTypeNumber: v => !isNaN(Number(v)) || 'El abono debe ser un número',
					greaterThanRemainingPercentage: v => Number(v) >= this.refund.remainingContract || 'El abono debe ser mayor o igual que el porcentaje del contrato restante (' + this.refund.remainingContract + '%)',
					lessThanRefundedPercentage: v => {
						let remaining_refund_percentage = Math.round((100 - this.refund.percentage) * 100) / 100;
						let rule = "";
						if (this.refund.percentage > 0)
							rule = 'Ya se ha abonado el ' + this.refund.percentage + '%. ';

						return Number(v) <= remaining_refund_percentage || rule + 'El abono debe ser menor que ' + remaining_refund_percentage + '%';
					},
					maxTwoDecimals: v => {
						const regex = /^-?\d+(\.\d{1,2})?$/;
						return regex.test(v) || 'Sólo se permiten hasta dos decimales';
					},
				},
				showDialog: false,
				loading: false,
				persistent: true,
				key: 0
			},
			addPaidUsers: {
				selectedItem: null,
				amount: null,
				extra_users_data: {
					users_num: 0,
					limit_users: 0,
					paid_extra_users: 0,
					gifted_users: 0,
				},
				form: {
					users_num: "",
					error: '',
					loading: false,
					validationRules: {
						required: v => !!v || 'Campo obligatorio',
						greaterThanZero: v => v > 0 || 'El número debe ser mayor que 0.',
						isTypeNumber: v => !isNaN(Number(v)) || 'El nº de usuarios debe ser un número',
					},
				},
				paymentFileForm: {
					payment_file: null,
					error: false,
					errorMsg: '',
					validationRules: {
						required: v => !!v || (v && v.size > 0) || 'Archivo requerido',
						fileType: v => {
							if (!v) return 'Archivo requerido';
							const allowedTypes = ['application/pdf'];
							return allowedTypes.includes(v.type) || 'Solo se permiten archivos PDF';
						},
						fileSize: v => {
							if (!v) return 'Archivo requerido';
							const maxSize = 10485760; // 10 MB
							return v.size <= maxSize || 'El archivo no puede superar los 10 MB';
						}
					},
				},
				showDialog: false,
				loading: false,
				// key: 0

			},
			updateUserTaxData: {
				showDialog: false,
				loading: false,
				selectedItem: null,
				mode: 'regenerate', // 'regenerate' = abono + factura, 'update_only' = solo datos fiscales
				businessData: {
					name: '',
					id: '',
					postalAddress: '',
					postCode: '',
					province: '',
				},
				validationRules: {
					required: v => !!v || 'Campo obligatorio',
					validNifOrCif: value => {
						if (!value) return true;
						return isValidDNI(value) || isValidCIF(value) || 'Debe ser un NIF o CIF válido';

						function isValidDNI(dni) {
							const match = dni.toUpperCase().match(/^(\d{8})([A-Z])$/);
							if (!match) return false;
							return 'TRWAGMYFPDXBNJZSQVHLCKE'[+match[1] % 23] === match[2];
						}

						function isValidCIF(cif) {
							cif = cif.toUpperCase();
							if (!/^[ABCDEFGHJKLMNPQRSUVW]\d{7}[0-9A-J]$/.test(cif)) return false;

							const digits = cif.slice(1, -1);
							const control = cif.slice(-1);
							let sum = 0;

							for (let i = 0; i < 7; i++) {
								let n = +digits[i];
								sum += i % 2 === 0 ? [...(n * 2 + '')].reduce((a, b) => +a + +b, 0) : n;
							}

							const checkDigit = (10 - sum % 10) % 10;
							const expected = /[KPQS]/.test(cif[0])
								? 'JABCDEFGHI'[checkDigit]
								: /[ABEH]/.test(cif[0])
									? String(checkDigit)
									: [String(checkDigit), 'JABCDEFGHI'[checkDigit]];

							return expected.includes(control);
						}
					}
				},
				form: {
					error: '',
					loading: false,
				},
			},
			additionalServices: {
				selectedItem: null,
				showDialog: false,
				loading: false,
				persistent: true,
				key: 2,
				paymentFileForm: {
					payment_file: null,
					error: false,
					errorMsg: '',
					validationRules: {
						required: v => !!v || (v && v.size > 0) || 'Archivo requerido',
						fileType: v => {
							if (!v) return 'Archivo requerido';
							const allowedTypes = ['application/pdf'];
							return allowedTypes.includes(v.type) || 'Solo se permiten archivos PDF';
						},
						fileSize: v => {
							if (!v) return 'Archivo requerido';
							const maxSize = 10485760; // 10 MB
							return v.size <= maxSize || 'El archivo no puede superar los 10 MB';
						}
					},
				},
			},
			sendTransactionsDialog: false,
			sendTransactionsLoading: false,
			textSnackbarOk: 'Cambios realizados con éxito.',
			textSnackbarKo: 'Compruebe que los valores en el formulario son válidos.',
			textSnackbarKoApi: 'Ha habido un problema con la operación.',
			modal_send_docs: {
				receiver_user: '',
				num_docs: '',
				contract_origin_id: '',
				max_docs_num: 0,
			},
			modal_send_transactions: {
				receiver_user: '',
				num_transactions: '',
				contract_origin_id: '',
				max_transactions_num: 0,
			},
			validationRules: {
				required: v => !!v || 'Campo obligatorio',
				greaterThanZero: v => v > 0 || 'El número debe ser mayor que 0.',
				limitDocsNum: v => v <= this.modal_send_docs.max_docs_num || 'El número máximo de documentos es ' + this.modal_send_docs.max_docs_num + '.',
				limitTransactionsNum: v => v <= this.modal_send_transactions.max_transactions_num || 'El número máximo de transacciones es ' + this.modal_send_transactions.max_transactions_num + '.',
			},
			receiverDocsUsers: [],
			promotional_code: undefined,
			receive_newsletter: false,
			receive_newsletter_loading: false,
			hasItemsBanksContractsValue: false,
			hasItemsBanksContractsDTBValue: false,
			hasItemsInstallationsValue: false,
			hasItemsAdditionalServicesValue: false,
			hasItemsWorkingHoursValue: false,
			hasItemsWorkingHoursClientValue: false,
			hasItemsEInvoiceContractsValue: false,
			hasItemsEInvoiceClientContractsValue: false,
			itemsEInvoiceContractsValue: [],
			itemsWorkingHoursValue: [],
			showSimpleCompanyPopup: false,
			availableCompanies: [],
			currentServiceDelivery: null,
			workingHoursTableKey: 0,
			available_space_information: {},
			screen_data_2: { // he cambiado el nombre, añadiendole '_2' para dejar la base de hexagonal bien hecha el que se debe usar es 'screen_data'
				payment_popup: new VuePaymentPopup(),
				selectCompanyPopup: new VueSelectEInvContractPopup(),
				selectWorkingHoursPopup: new VueSelectWorkingHoursContractPopup(),
				selectWorkingHoursOwnerPopup: new VueSelectWorkingHoursContractPopup(),
			},
			hasItemDocsContractsValue: false,
			loadingDownloadExe: false,
			profileClientUpdate: {
				bussnies_id: '',
				business_name: '',
				postal_address: '',
				post_code: '',
				province: ''
			},
			profileClientUpdateLoading: false,
			taxDataSaved: false,
			showDialogActivateTrialFacturaeClient: false,
			companyActivateTrialClient: null,
			crearConcessionButtonVisibility: true,
			extendTrialCreditsButtonVisibility: false,
			canExtendDocuments: false,
			canExtendBanks: false,
			worker_version: undefined,
		}
	},
	computed: {
		...mapGetters({
			me: 'me/me',
			userData: 'me/userData',
			profile: 'me/profile',
			show_contract: 'dialog_contract/show_contract',
			price: 'me/price',
			docs_num: 'me/docs_num',
			firm_date: 'me/firm_date',
			show_policy_privacity: 'dialog_contract/show_policy_privacity',
			show_data_treatment: 'dialog_contract/show_data_treatment',
			permission: 'permissions/permission',
			got_feature: 'got_feature',
			exe_link: "tutorial/exe_link",
			get_companydbs: 'get_companydbs',
			hasWorkingHoursContract: 'hasWorkingHoursContract',
			hasEverHadWorkingHoursContract: 'hasEverHadWorkingHoursContract',
			hasExpiredWorkingHoursContract: 'hasExpiredWorkingHoursContract',
		}),
		...mapFields('dialog_payment', ['show_contract_modal']),
		showContractModal() {
			return this.show_contract_modal;
		},
		...mapState(['session_information']),
		i_am_staff() {
			return this.userData.is_staff
		},
		i_am_loginas() {
			return (this.userData.hasOwnProperty('username') && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username))
		},
		i_am_owner_and_feature_send_docs() {
			return this.got_feature('feature_send_docs') && this.permission.is_owner
		},
		invoiceRegenerable() {
			return this.i_am_staff || this.i_am_loginas;
		},
		extendTrialCreditsLabel() {
			return this.modal_extend_trial_docs.contract_kind === 'documents'
				? '¿Cuántos documentos quieres añadirle?'
				: '¿Cuántas transacciones quieres añadirle?';
		},
		currentTrialLimit() {
			const kind = this.modal_extend_trial_docs.contract_kind;
			const contracts = kind === 'documents' ? this.userData.contracts : this.userData.all_contracts;
			if (!Array.isArray(contracts)) return null;
			const contract = contracts.find(c =>
				c.is_trial === true &&
				c.kind === kind &&
				c.is_finished === false
			);
			if (!contract) return null;
			if (kind === 'documents') {
				return contract.trial_limit || 25;
			} else {
				return (contract.configuration && contract.configuration.trial_limit) || 100;
			}
		},
		newTrialLimit() {
			const extra = Number(this.modal_extend_trial_docs.extra_credits) || 0;
			return (this.currentTrialLimit || 0) + extra;
		},
		trialCreditsUnit() {
			return this.modal_extend_trial_docs.contract_kind === 'documents' ? 'documentos' : 'transacciones';
		},
		disabledDocumentsMessage() {
			if (!Array.isArray(this.userData.contracts)) return 'No hay contratos disponibles';
			const trialContract = this.userData.contracts.find(c =>
				c.is_trial === true && c.kind === 'documents' && c.is_finished === false
			);
			if (!trialContract) return 'No hay contrato trial de documentos activo';
			return '';
		},
		disabledBanksMessage() {
			if (!Array.isArray(this.userData.all_contracts)) return 'No hay contratos disponibles';
			const trialContract = this.userData.all_contracts.find(c =>
				c.is_trial === true && c.kind === 'banks' && c.is_finished === false
			);
			if (!trialContract) return 'No hay contrato trial de bancos activo';
			return '';
		},
		showContractServiceButton() {
			return canUserContractService(this.userData);
		},
		getContractHeaders() {
			let res = structuredClone(this.defaultContractsHeaders);
			if (this.got_feature('feature_credit_expense')) {
				res = res.filter(h => h.value !== 'used_docs_num' && h.value !== 'docs_num_ini');
				const credits_col = {
					text: 'Documentos',
					value: 'credits_usage',
					sortable: false,
					align: 'start'
				}
				res.splice(1, 0, credits_col);
			}
			if (this.got_feature('feature_payment_on_inmatic') && !this.userData.sender_docs_user_distributor_code) {
				const payment_col = {
					text: 'Factura',
					value: 'invoice_pdf',
					sortable: false,
					align: 'start',
					type: 'html',
				}
				res = res.concat([payment_col]);
			}
			if (this.got_feature('feature_cliente_glasof')) {
				const docs_col = {
					text: 'Documentos restantes',
					value: 'docs_num_resta',
					sortable: false,
					align: 'start'
				}
				res.splice(2, 0, docs_col)
			}
			if (this.i_am_staff || this.i_am_loginas || this.i_am_owner_and_feature_send_docs) {
				const actions_col = {
					text: 'Acciones',
					value: 'actions',
					sortable: false,
					align: 'end',
				}
				res = res.concat([actions_col]);
			}
			if (this.got_feature('feature_purchase_extra_users')) {
				const users_col = [{
					text: 'Usuarios',
					value: 'total_extra_users',
					sortable: false,
					align: 'start',
				}];
				res = [...res.slice(0, 3), ...users_col, ...res.slice(3)];
			}
			return res;
		},
	},
	watch: {
		profileClientUpdate: {
			handler(newVal, oldVal) {
				// Solo marcar como no guardados si realmente hubo un cambio después de la inicialización
				// y si taxDataSaved era true (es decir, los datos estaban guardados previamente)
				if (oldVal && this.taxDataSaved) {
					this.taxDataSaved = false;
				}
			},
			deep: true
		},
		'userData.contracts': {
			async handler(newContracts, oldContracts) {
				// Detectar cuando se activa un trial o se contrata FE o WH
				if (newContracts && oldContracts && newContracts.length !== oldContracts.length) {
					// Se ha añadido o eliminado un contrato, recargar los datos del perfil
					this.initProfileClientUpdate();
					// Actualizar la visibilidad de los servicios
					if (this.component) {
						this.component.screen_data.user_has_some_facturae_service = newContracts.some(c =>
							c.name && c.name.toLowerCase().includes('factura')
						);
					}
					// Esperar un momento para que el backend se sincronice
					await new Promise(resolve => setTimeout(resolve, 500));
					// Actualizar el menú lateral (zonas) para reflejar el nuevo contrato
					const currentCompany = this.$store.getters.getCurrentCompany;
					if (currentCompany && currentCompany.id) {
						await this.$store.dispatch('setZones', currentCompany.id);
					}
				}
			},
			deep: true
		}
	},
	methods: {
		...mapActions({
			forceRefreshUserData: "me/forceRefreshUserData",
			showContract: "dialog_contract/showContract",
			showDataTreatment: "dialog_contract/showDataTreatment",
			showPolicyPrivacity: "dialog_contract/showPolicyPrivacity",
			hideContract: "dialog_contract/hideContract",
			hidePolicyPrivacity: "dialog_contract/hidePolicyPrivacity",
			hideDataTreatment: "dialog_contract/hideDataTreatment",
			changePasswordAction: "changePassword",
			setMessageModal: 'messageModal/setModal',
			closeMessageModal: 'messageModal/closeModal',
			openContractModal: 'dialog_payment/openContractModal',
			openExtraUserContractPopup: 'dialog_payment/openExtraUserContractPopup',
			openPayChargePopupAction: 'dialog_payment/openPayChargePopup',
			setExeLink: "tutorial/setExeLink",
		}),
		contractActionBtnList(type) {
			const sendDocuments = {'name': 'Traspasar Documentos', 'action': 'send_documents', 'icon': 'mdi-transfer'};
			const createRefund = {'name': 'Realizar abono', 'action': 'create_refund', 'icon': 'mdi-account-credit-card-outline', 'visibility': ['is_refundable', 'remaining_contract_percentage']};
			const regenerateInvoiceWithUpdatedTaxData = {'name': 'Regenerar factura con datos fiscales cambiados', 'action': 'regenerate_invoice_with_updated_taxdata', 'icon': 'mdi-file-document-refresh-outline', 'visibility': 'is_taxdata_renewable'};
			const transferTransactions ={ 'name': 'Traspasar Transacciones', 'action': 'send_transactions', 'icon': 'mdi-wrench-outline' };
			const conmpaniesConf =  { 'name': 'Configurar mis empresas', 'action': 'select_company_to_e_inv_contract', 'icon': 'icon-select-company.svg' , 'is_svg': true};
			let actions = [];
			if (this.i_am_owner_and_feature_send_docs && type == 'documents') {
				actions.push(sendDocuments);
			}
			if (type == 'banks') {
				actions.push(transferTransactions);
			}
			if (type == 'eInvoice') {
				actions.push(conmpaniesConf);
			}
			
			if (this.i_am_staff || this.i_am_loginas) {
				let refundBtn = { ...createRefund };
				if (type == 'installation') {
					refundBtn.visibility = ['charge.invoice_pdf_url', 'charge.is_refundable'];
				}else if (type == 'additionalServices') {
					refundBtn.visibility = ['invoice_pdf_url', 'is_refundable'];
				}else if (type == 'workingHours') {
					refundBtn.visibility = ['invoice_pdf', 'is_refundable'];
				}
				actions.push(refundBtn)
				if (type !== 'installation' && type !== 'additionalServices')
					actions.push(regenerateInvoiceWithUpdatedTaxData)
			}
			return actions;
		},
		setupAWSCredentials() {
			this.creds = new AWS.CognitoIdentityCredentials({ IdentityPoolId: awsconfig['aws_cognito_identity_pool_id'] });
			this.creds.params.Logins = this.creds.params.Logins || {};
			this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] = this.session_information.signInUserSession.idToken.jwtToken;
			this.creds.expired = true;
			AWS.config.update({
				region: awsconfig['aws_user_files_s3_bucket_region'],
				credentials: this.creds,
			});
		},
		async descargar_inmaticLink() {
			this.loadingDownloadExe = true;
			let startsWith = ''
			if (this.userData.distributor_code == 'docunecta') {
				startsWith = 'DCXAPP32'
			} else if (this.userData.distributor_code == 'glasof') {
				startsWith = 'GSFAPP32'
			} else {
				startsWith = 'INMAPP32'
			}
			await this.setExeLink(startsWith);
			navigator.clipboard.writeText(this.exe_link);
			this.loadingDownloadExe = false;
		},
		showContractBtn: function () {
			return this.userData && this.userData.available_features && this.userData.available_features.feature_show_contract;
		},
		showPolicyPrivacityBtn: function () {
			return this.got_feature('feature_show_policy_privacity');
		},
		showDataTreatmentBtn: function () {
			return this.got_feature('feature_show_policy_privacity');
		},
		showAllFields: function () {
			return this.permission.is_owner;
		},
		confirmChangePassword() {
			this.changePassword.form.error = false
			const isValid = this.$refs.form.validate()
			if (isValid) {
				this.loading = true;
				let that = this;
				this.changePasswordAction({
					oldpassword: this.changePassword.form.oldpassword,
					password: this.changePassword.form.password1,
				}).then(result => {
					that.resetChangePassword();
					that.changePassword.loading = false;
					that.setSnackbar('success', 'Contraseña cambiada correctamente.')
				}, error => {
					that.changePassword.loading = false;
					that.changePassword.form.error = error.message;
					that.setSnackbar('error', 'Ha habido un error durante el proceso.')
					console.error(error);
				});
			} else {
				this.setSnackbar('error', 'Revise los errores del formulario.')
			}
		},
		resetChangePassword() {
			var form = {
				showOldPassword: false,
				showPassword1: false,
				showPassword2: false,
				oldpassword: '',
				password1: '',
				password2: '',
				error: '',
				loading: false,
				isPassChanged: false,
			}
			Object.assign(this.changePassword.form, form);
			this.changePassword.showDialog = false;
		},
		setSnackbar(color, text) {
			this.snackbar.text = text
			this.snackbar.color = color
			this.snackbar.isVisible = true
		},
		showChangePassword() {
			this.changePassword.showDialog = true;
		},
		getInvoiceDistributorContractsHeaders() {
			let invoice_dist_headers = this.defaultContractsHeaders;
			const trial_col = {
				text: 'Contratado',
				value: 'is_trial',
				sortable: false,
				align: 'start',
				type: 'boolean',
			}
			invoice_dist_headers = invoice_dist_headers.concat([trial_col]);
			if (this.userData.distributor_code) {
				const user_col = {
					text: 'Usuario',
					value: 'username',
					sortable: false,
					align: 'start',
				}
				invoice_dist_headers = invoice_dist_headers.concat([user_col]);
			}
			if (this.got_feature('feature_payment_on_inmatic') && !this.userData.sender_docs_user_distributor_code || this.userData.distributor_code == this.userData.sender_docs_user_distributor_code) {
				const payment_col = {
					text: 'Factura',
					value: 'invoice_pdf',
					sortable: false,
					align: 'start',
					type: 'html',
				}
				invoice_dist_headers = invoice_dist_headers.concat([payment_col])
			}
			return invoice_dist_headers;
		},
		geteInvoiceContractsHeaders() {
			let result = this.eInvoiceContractsHeaders
			if (this.got_feature('feature_buy_facturae_for_client')) {
				const client_col = {
					text: 'Cliente',
					value: 'client_service_delivery',
					sortable: false,
					align: 'start'
				}
				result = result.concat([client_col])
			}
			if (this.got_feature('feature_purchase_extra_users')) {
				const users_col = [{
					text: 'Usuarios',
					value: 'total_extra_users',
					sortable: false,
					align: 'start',
				}];
				result = [...result.slice(0, 2), ...users_col, ...result.slice(2)];
			}
			return result;
		},
		getBankContractsHeaders() {
			let result = structuredClone(this.defaultBankContractsHeaders);
			if (this.got_feature('feature_credit_expense')) {
				result = result.filter(h => h.value !== 'transactions');
				const credits_col = {
					text: 'Transacciones',
					value: 'credits_usage',
					sortable: false,
					align: 'start'
				}
				result.splice(1, 0, credits_col);
			}
			if (this.got_feature('feature_payment_on_inmatic') && !this.userData.sender_docs_user_distributor_code) {
				const payment_col = {
					text: 'Factura',
					value: 'invoice_pdf',
					sortable: false,
					align: 'start',
					type: 'link',
					link_text: 'Descargar'
				}
				result = result.concat([payment_col]);
			}
			if (this.got_feature('feature_send_docs') && this.permission.is_owner) {
				const actions_col = {
					text: '',
					align: 'end',
					value: 'actions',
					sortable: false,
				}
				result = result.concat([actions_col])
			}
			if (this.i_am_staff || this.i_am_loginas || this.i_am_owner_and_feature_send_docs) {
				const actions_col = {
					text: 'Acciones',
					value: 'actions',
					sortable: false,
					align: 'end',
				}
				result = result.concat([actions_col]);
			}
			if (this.got_feature('feature_purchase_extra_users')) {
				const users_col = [{
					text: 'Usuarios',
					value: 'total_extra_users',
					sortable: false,
					align: 'start',
				}];
				result = [...result.slice(0, 2), ...users_col, ...result.slice(2)];
			}
			return result;
		},
		getBankDistributorContractsHeaders() {
			let bank_dist_headers = this.defaultBankContractsHeaders;
			if (this.userData.distributor_code) {
				const user_col = {
					text: 'Usuario',
					value: 'organization_username',
					sortable: false,
					align: 'start',
				}
				bank_dist_headers = bank_dist_headers.concat([user_col]);
				const payment_col = {
					text: 'Factura',
					value: 'invoice_pdf',
					sortable: false,
					align: 'start',
					type: 'link',
					link_text: 'Descargar'
				}
				bank_dist_headers = bank_dist_headers.concat([payment_col]);
			}
			return bank_dist_headers;
		},
		getInstallationHeaders() {
			let result = this.installationHeaders;
			if (this.i_am_staff || this.i_am_loginas) {
				const actions_col = {
					text: 'Acciones',
					value: 'actions',
					sortable: false,
					align: 'end',
				}
				result = result.concat([actions_col]);
			}
			return result;
		},
		getAdditionalServicesHeaders() {
			let result = this.additionalServicesHeaders;
			if (this.i_am_staff || this.i_am_loginas) {
				const actions_col = {
					text: 'Acciones',
					value: 'actions',
					sortable: false,
					align: 'end',
				}
				result = result.concat([actions_col]);
			}
			return result;
		},
		getWorkingHoursHeaders() {
			let result = this.workingHoursHeaders;

			// El botón "Configurar mis empresas" ahora se muestra dentro de la columna "Empresa"
			// cuando organization_name está vacío, así que no necesitamos columna separada

			const client_col = {
				text: 'Cliente',
				value: 'client_service_delivery',
				sortable: false,
				align: 'start'
			}
			result = result.concat([client_col])
			if (this.got_feature('feature_purchase_extra_users')) {
			 	const users_col = [{
			 		text: 'Usuarios',
			 		value: 'total_extra_users',
			 		sortable: false,
			 		align: 'start',
			 	}];
			 	// Insertar la columna de usuarios extra después de "Concepto"
			 	result = [...result.slice(0, 1), ...users_col, ...result.slice(1)];
			}
			if (this.i_am_staff || this.i_am_loginas) {
				const actions_col = {
					text: 'Acciones',
					value: 'actions',
					sortable: false,
					align: 'end',
				}
				result = result.concat([actions_col]);
			}
			return result;
		},
		async clickUserTableActionBtn(action, item, tableRef = 'contractsTable') {
			this.actionModal = action;
			this.sourceTable = tableRef;
			if (action == 'send_documents') {
				if (item.is_done) {
					this.setMessageModal({
						text: 'El contrato ha finalizado. No se pueden traspasar documentos de este contrato.',
						actionConfirmButton: this.closeMessageModal
					})
				} else {
					this.openSendDocsDialog(item);
				}
			} else if (action == 'send_transactions') {
				if (item.is_done) {
					this.setMessageModal({
						text: 'El contrato ha finalizado. No se pueden traspasar transacciones de este contrato.',
						actionConfirmButton: this.closeMessageModal
					})
				} else {
					this.openSendTransactionsDialog(item);
				}
			} else if (action == 'regenerate_invoice') {
				let error = null;

				if (!this.exists_charge_id(item)) {
					error = "Falta un charge_id para poder facturar";
				} else if (!this.is_current_year(item)) {
					error = "La factura no corresponde al ejercicio actual";
				} else if (this.exists_invoice(item)) {
					error = "Factura ya existente, no se puede regenerar";
				} else if (this.exists_payment_file(item)) {
					error = "No existe justificante de pago";
				}
				if (error) { 
					this.setMessageModal({
						text: error,
						actionConfirmButton: this.closeMessageModal
					})
				} else {
					this.$set(item, 'action', action);
					this.APIregenerateInvoice(item);
				}
			} else if (action == 'create_concession') {
				let error = null;

				if (error) {
					this.setMessageModal({
						text: error,
						actionConfirmButton: this.closeMessageModal
					})
				} else {
					this.createConcessionDialog = true;
				}
			} else if (action == 'create_refund') {
				this.refund.loading = false;
				let error = null;
				if (error) {
					this.setMessageModal({ text: error, actionConfirmButton: this.closeMessageModal, })
				} else {
					this.refund.selectedItem = item;
					this.refund.key++;
					this.refund.remainingContract = item.remaining_contract_percentage;
					let refundPercent  = item.refund_percentage !== undefined ? item.refund_percentage : item.charge.refund_percentage;
					this.refund.percentage = +(refundPercent < 1 ? refundPercent * 100 : refundPercent).toFixed(2);
					let remaining_refund_percentage = Math.round((100 - parseFloat(this.refund.percentage)) * 100) / 100;
					this.refund.form.percentage =  String(this.refund.remainingContract < remaining_refund_percentage ? this.refund.remainingContract : remaining_refund_percentage);
					this.refund.showDialog = true;
					this.$set(item, 'action', action);
				}
			} else if (action == 'regenerate_invoice_with_updated_taxdata') {
				this.$set(item, 'action', action);
				this.updateUserTaxData.showDialog = true;
				this.updateUserTaxData.selectedItem = item;
				this.updateUserTaxData.businessData.name = this.profile.form.business_name
				this.updateUserTaxData.businessData.id = this.profile.form.bussnies_id
				this.updateUserTaxData.businessData.postalAddress = this.profile.form.postal_address
				this.updateUserTaxData.businessData.postCode = this.profile.form.post_code
				this.updateUserTaxData.businessData.province = this.profile.form.province	
			} else if(action == "select_company_to_e_inv_contract"){
				console.log("SelectCompanyToEInvContract")
				let sdItem = this.itemsEInvoiceContractsValue.find(i => i.sd_id === item.sd_id);
				let sd = new ServiceDelivery(
					sdItem.sd_id, // sd_id
					this.userData.user, // user_id
					sdItem.name, // contract_type
					true, // status
					sdItem.total_credits, // credits
					sdItem.companies // companies
				)
				let sd_repo = new APIServiceDeliveryRepository([sd])
				let company_repo = new APICompanyRepository()
				let cmd = new SelectCompaniesSD(this.screen_data_2, company_repo, sd_repo)
				await cmd.execute(sd)
			}
		},
		clickOpenModalInvoicesList(item) {
			this.invoicesList.showDialog = true;
			this.invoicesList.count = item.charges_count;
			this.invoicesList.pdfs = item.invoices_list_pdfs;
		},
		// sergiiiiiiiiiiiiiiiiiiii
		clickAddPaidUsers(item) {
			this.addPaidUsers.selectedItem = item;
			this.addPaidUsers.extra_users_data = item.extra_users_data;
			this.addPaidUsers.amount = Math.round(item.extra_users_price * (item.remaining_contract_percentage / 100) * 100) / 100;
			this.addPaidUsers.showDialog = true;
			this.openExtraUserContractPopup({contract: item})
		},
		clickOpenModalUploadPaymentFile(item) {
			this.additionalServices.key += 2;
			this.additionalServices.showDialog = true;
			this.additionalServices.selectedItem = item;
			this.additionalServices.amount = this.formatAmount(item.total_amount);
		},
		openPayChargePopup(item){
			this.openPayChargePopupAction({charge: item})
		},
		formatAmount(float) {
			let parsed = parseFloat(float);
			let needsDecimals = parsed % 1 !== 0;
			return new Intl.NumberFormat('es-ES', { minimumFractionDigits: needsDecimals ? 2 : 0, maximumFractionDigits: 2 }).format(parsed);
		},
		is_current_year(item) {
			let date, year;
			let current_year = new Date().getFullYear();
			if (item.charge && item.charge.charge_date) {
				date = item.charge.charge_date;
				if (date)
					year = new Date(item.charge.charge_date).getFullYear();
			} else 
				date = item.start_date || item.charge_date;
			if (!date) return false;
			const parts = date.split(' ')[0].split('-');
			if (!year)
				year = parts[2];
			return year==current_year;
		},
		exists_invoice(item) {
			return !((item.invoice === undefined || item.invoice == "") && (item.invoice_pdf === undefined || item.invoice_pdf == ""));
		},
		exists_payment_file(item) {
			return !((item.payment_file === undefined || item.payment_file == "") && (item.payment_file_pdf === undefined || item.payment_file_pdf == ""));
		},
		exists_charge_id(item) {
			const chargeId = item.charge_id;
			const nestedChargeId = item.charge && item.charge.charge_id;
			return (chargeId != null && chargeId !== '') || (nestedChargeId != null && nestedChargeId !== '');
		},
		openSendDocsDialog(item) {
			if (this.$refs && this.$refs.sendDocsDialogForm) {
				this.$refs.sendDocsDialogForm.reset();
			}
			this.resetModalSendDocsValues();
			this.modal_send_docs.contract_origin_id = item.id;
			this.modal_send_docs.max_docs_num = item.docs_num - item.used_docs;
			this.getReceiverDocsUsers();
			this.sendDocsDialog = true;
		},
		async getReceiverDocsUsers() {
			this.receiverDocsUsers = await new ReceiverDocsUsersQuery(query_dispatcher).run();
		},
		openSendTransactionsDialog(item) {
			if (this.$refs && this.$refs.sendTransactionsDialogForm) {
				this.$refs.sendTransactionsDialogForm.reset();
			}
			this.resetModalSendTransactionsValues();
			this.modal_send_transactions.contract_origin_id = item.sd_id;
			this.modal_send_transactions.max_transactions_num = item.total_transactions - item.count;
			this.getReceiverDocsUsers();
			this.sendTransactionsDialog = true;
		},
		async getReceiverDocsUsers() {
			this.receiverDocsUsers = await new ReceiverDocsUsersQuery(query_dispatcher).run();
		},
		setSnackbar(color, text) {
			if (text != '') {
				this.snackbar.text = text;
				this.snackbar.isVisible = true;
				this.snackbar.color = color;
			}
			else {
				this.snackbar.text = '';
				this.snackbar.isVisible = false;
			}
		},
		openModalCreateConcession() {
			this.actionModal = "create_concession";
			this.modal_create_concession.dialog = true;
		},
		confirmCreateConcession() {
			if (this.$refs.createConcessionForm.validate()) {
				this.modal_create_concession.dialog = false;
				this.APIcreateConcession();
			}
		},
		cancelCreateConcession() {
			this.modal_create_concession.dialog = false;
		},
		openModalExtendTrialDocs() {
			this.actionModal = "extend_trial_docs";
			this.modal_extend_trial_docs.dialog = true;
			this.$nextTick(() => {
				if (this.$refs.extendTrialDocsForm) {
					this.$refs.extendTrialDocsForm.resetValidation();
				}
			});
		},
		confirmExtendTrialDocs() {
			if (this.$refs.extendTrialDocsForm.validate()) {
				this.modal_extend_trial_docs.dialog = false;
				this.APIextendTrialDocs();
			}
		},
		cancelExtendTrialDocs() {
			this.modal_extend_trial_docs.dialog = false;
		},
		openModalChangeEndDate() {
			this.actionModal = "change_end_date";
			this.modal_change_end_date.error = null;
			this.modal_change_end_date.dialog = true;
			this.$nextTick(() => {
				if (this.$refs.changeEndDateForm) {
					this.$refs.changeEndDateForm.resetValidation();
				}
			});
		},
		async confirmChangeEndDate() {
			this.modal_change_end_date.error = null;
			if (!this.$refs.changeEndDateForm.validate()) {
				return;
			}
			try {
				this.modal_change_end_date.loading = true;
				const contractId = Number(this.modal_change_end_date.contract_id);
				const currentUserId = this.userData.user;
				const currentUserUsername = this.userData.username;
				const result = await new CheckContractExistsQuery(query_dispatcher).run(contractId, currentUserId, currentUserUsername);
				if (!result.exists) {
					this.modal_change_end_date.error = result.reason || `No se encontró el contrato ${contractId} o no tienes permisos para modificarlo`;
					this.modal_change_end_date.loading = false;
					return;
				}
				this.modal_change_end_date.dialog = false;
				this.APIchangeEndDate();
			} catch (error) {
				this.modal_change_end_date.error = `Error al verificar el contrato: ${error.message || error}`;
				this.modal_change_end_date.loading = false;
			}
		},
		cancelChangeEndDate() {
			this.modal_change_end_date.dialog = false;
		},
		async APIchangeEndDate() {
			try {
				this.modal_change_end_date.loading = true;
				const contractId = Number(this.modal_change_end_date.contract_id);
				let response = await new ChangeEndDateCommand(sync_command_dispatcher).run(
					contractId,
					this.modal_change_end_date.end_date,
					this.modal_change_end_date.reason,
					this.session_information.username
				);
				if (response && response.output && response.output.success) {
					this.setSnackbar('success', `Fecha cambiada de ${response.output.old_end_date} a ${response.output.new_end_date}`);
					this.forceRefreshUserData();
				} else {
					// Mostrar mensaje de error específico del backend
					const errorMsg = (response && response.output && response.output.error) || 'Error al cambiar la fecha';
					this.setSnackbar('error', errorMsg);
				}
			} catch (error) {
				this.setSnackbar('error', error.message || error);
			}
			this.modal_change_end_date.loading = false;
		},

		openModalAddNote() {
			this.actionModal = "add_note";
			this.modal_add_note.error = null;
			this.modal_add_note.dialog = true;
			this.$nextTick(() => {
				if (this.$refs.addNoteForm) {
					this.$refs.addNoteForm.resetValidation();
				}
			});
		},
		async confirmAddNote() {
			this.modal_add_note.error = null; // Resetear error
			if (!this.$refs.addNoteForm.validate()) { // Validar formulario
				return;
			}
			try {
				// Verificar que el contrato existe y pertenece al usuario correcto
				this.modal_add_note.loading = true;
				const contractId = Number(this.modal_add_note.contract_id);
				const currentUserId = this.userData.user; // userData.user = id i userData.id és el id del profile
				const currentUserUsername = this.userData.username;
				const result = await new CheckContractExistsQuery(query_dispatcher).run(contractId, currentUserId, currentUserUsername);
				console.log(result)
				if (!result.exists) {
					// El contrato no existe o no pertenece al usuario
					this.modal_add_note.error = result.reason || `No se encontró el contrato ${contractId} o no tienes permisos para modificarlo`;
					this.modal_add_note.loading = false;
					return;
				}
				// El contrato existe y pertenece al usuario, cerrar modal y ejecutar comando
				this.modal_add_note.dialog = false;
				this.APIaddNoteToContract();
			} catch (error) {
				console.error('Error al verificar el contrato:', error);
				this.modal_add_note.error = `Error al verificar el contrato: ${error.message || error}`;
				this.modal_add_note.loading = false;
			}
		},
		cancelAddNote() {
			this.modal_add_note.dialog = false;
		},
		async APIaddNoteToContract() {
			try {
				this.modal_add_note.loading = true;
				const contractId = Number(this.modal_add_note.contract_id);
				let response = await new AddNoteToContractCommand(sync_command_dispatcher).run(
					contractId,//el contracte al qual se li asigna
					this.modal_add_note.reason, //la nota en sí
					this.userData.user, //l'usuari
					this.session_information.username //nom de l'staff
				)
				if (response && response.output.success) {
					this.setSnackbar('success', 'Nota añadida correctamente');
					// Refrescar los datos del contrato si es necesario
					if (this.$refs.docContractsTable) {
						this.$refs.docContractsTable.get_items();
					}
				} else {
					this.setSnackbar('error', 'Error al añadir la nota');
				}
			}
			catch (error) {
				console.log(error)
				this.setSnackbar('error', error.message || error);
			}
			this.modal_add_note.selectedItem = {};
			this.modal_add_note.loading = false;
		},
		openModalChangeName() {
			this.actionModal = "change_name";
			this.modal_change_name.error = null;
			this.modal_change_name.dialog = true;
			this.$nextTick(() => {
				if (this.$refs.changeNameForm) {
					this.$refs.changeNameForm.resetValidation();
				}
			});
		},
		async confirmChangeName() {
			this.modal_change_name.error = null; // Resetear error
			if (!this.$refs.changeNameForm.validate()) { // Validar formulario
				return;
			}
			try {
				// Verificar que el contrato existe y pertenece al usuario correcto
				this.modal_change_name.loading = true;
				const contractId = Number(this.modal_change_name.contract_id);
				const currentUserId = this.userData.user;
				const currentUserUsername = this.userData.username;
				const result = await new CheckContractExistsQuery(query_dispatcher).run(contractId, currentUserId, currentUserUsername);
				console.log(result)
				if (!result.exists) {
					// El contrato no existe o no pertenece al usuario
					this.modal_change_name.error = result.reason || `No se encontró el contrato ${contractId} o no tienes permisos para modificarlo`;
					this.modal_change_name.loading = false;
					return;
				}
				// El contrato existe y pertenece al usuario, cerrar modal y ejecutar comando
				this.modal_change_name.dialog = false;
				this.APIchangeContractName();
			} catch (error) {
				console.error('Error al verificar el contrato:', error);
				this.modal_change_name.error = `Error al verificar el contrato: ${error.message || error}`;
				this.modal_change_name.loading = false;
			}
		},
		cancelChangeName() {
			this.modal_change_name.dialog = false;
		},
		async APIchangeContractName() {
			try {
				this.modal_change_name.loading = true;
				const contractId = Number(this.modal_change_name.contract_id);
				let response = await new ChangeContractNameCommand(sync_command_dispatcher).run(
					contractId,
					this.modal_change_name.new_name,
					this.modal_change_name.reason,
					this.userData.user,
					this.session_information.username
				)
				if (response && response.output.success) {
					this.setSnackbar('success', 'Nombre del contrato cambiado correctamente');
					this.forceRefreshUserData();
				} else {
					this.setSnackbar('error', (response && response.output && response.output.message) || 'Error al cambiar el nombre del contrato');
				}
			}
			catch (error) {
				console.log(error)
				this.setSnackbar('error', error.message || error);
			}
			this.modal_change_name.selectedItem = {};
			this.modal_change_name.loading = false;
			this.modal_change_name.contract_id = null;
			this.modal_change_name.new_name = null;
			this.modal_change_name.reason = null;
		},
		confirmCreaterefund() {
			this.refund.form.error = false
			const isValid = this.$refs.form.validate()
			if (isValid) {
				this.refund.loading = true;
				let charge_id = this.refund.selectedItem.charge_id != null ? this.refund.selectedItem.charge_id : this.refund.selectedItem.charge.charge_id;
				let amount = this.refund.selectedItem.charge_amount != null ? this.refund.selectedItem.charge_amount : this.refund.selectedItem.charge.amount;
				let sd_id = this.refund.selectedItem.id != null ? this.refund.selectedItem.id : this.refund.selectedItem.sd_id;
				let product_code = this.refund.selectedItem.product_code != undefined ? this.refund.selectedItem.product_code : null;
				this.APIcreateRefund(sd_id, charge_id, amount, Number(this.refund.form.percentage), product_code);
			} else {
				this.setSnackbar('error', 'Revise los errores del formulario.')
			}
		},
		cancelCreaterefund() {
			this.refund.showDialog = false;
			var form = {
				error: '',
				loading: false,
			}
			Object.assign(this.refund.form, form);
		},
		confirmUpdateUserTaxData() {
			this.updateUserTaxData.form.error = false
			const isValid = this.$refs.form.validate()
			if (isValid) {
				this.updateUserTaxData.loading = true;
				if (this.updateUserTaxData.mode === 'update_only') {
					this.APIUpdateFiscalDataOnly();
				} else {
					this.APIRegenerateInvoiceWithUpdatedTaxData(this.userData.id, this.updateUserTaxData.selectedItem, this.updateUserTaxData.businessData);
				}
			} else {
				this.setSnackbar('error', 'Revise los errores del formulario.')
			}
		},
		cancelUpdateUserTaxData() {
			this.updateUserTaxData.showDialog = false;
			this.updateUserTaxData.mode = 'regenerate';
			var form = { error: '', loading: false, }
			Object.assign(this.updateUserTaxData.form, form);
		},
		openUpdateFiscalDataOnly() {
			this.updateUserTaxData.mode = 'update_only';
			this.updateUserTaxData.showDialog = true;
			this.updateUserTaxData.businessData.name = this.profile.form.business_name;
			this.updateUserTaxData.businessData.id = this.profile.form.bussnies_id;
			this.updateUserTaxData.businessData.postalAddress = this.profile.form.postal_address;
			this.updateUserTaxData.businessData.postCode = this.profile.form.post_code;
			this.updateUserTaxData.businessData.province = this.profile.form.province;
		},
		async APIUpdateFiscalDataOnly() {
			try {
				const businessData = this.updateUserTaxData.businessData;
				let response = await new UpdateFiscalDataUserCommand(sync_command_dispatcher).run(
					this.userData.id,
					businessData.name,
					businessData.id,
					businessData.postalAddress,
					businessData.postCode,
					businessData.province
				);
				if (response.output.status == 'success') {
					this.setSnackbar('success', response.output.message);
					// Actualizar datos locales
					this.profile.form.business_name = businessData.name;
					this.profile.form.bussnies_id = businessData.id;
					this.profile.form.postal_address = businessData.postalAddress;
					this.profile.form.post_code = businessData.postCode;
					this.profile.form.province = businessData.province;
				} else if (response.output.status == 'error') {
					this.setSnackbar('error', response.output.message);
				} else {
					this.setSnackbar('error', "Error al actualizar los datos fiscales");
				}
			} catch (error) {
				console.error(error);
				this.setSnackbar('error', "Error al actualizar los datos fiscales");
			}
			this.updateUserTaxData.loading = false;
			this.updateUserTaxData.showDialog = false;
			this.updateUserTaxData.mode = 'regenerate';
		},
		confirminvoicesList(item) {
			this.invoicesList.showDialog = false;
		},
		// confirmAdditionalServicesUploadFfile() {
		// 	this.APIAdditionalServiceUploadPaymentFile();
		// },
		resetAddPaidUsersForms(){
			var form = { users_num: "", error: '', loading: false, }
			this.$refs.form.resetValidation();
			Object.assign(this.addPaidUsers.form, form);
			var paymentFileForm = { payment_file: null, error: false, loading: false, errorMsg: '' }
			this.$refs.paymentFileForm.resetValidation();
			Object.assign(this.addPaidUsers.paymentFileForm, paymentFileForm);
		},
		// confirmAddPaidUsers(item) {
		// 	const isValid = this.$refs.form.validate()
		// 	if (isValid) 
		// 		this.APIPurchaseExtraUsers();
		// 		this.addPaidUsers.showDialog = false;
		// 		this.addPaidUsers.loading = false;
		// 		this.addPaidUsers.selectedItem = {};
		// 		this.addPaidUsers.amount = null;
		// 		this.resetAddPaidUsersForms();
		// },
		// cancelAdditionalServicesUploadFfile() {
		// 	this.additionalServices.showDialog = false;
		// 	this.additionalServices.selectedItem = null;
		// 	this.additionalServices.loading = false;
		// 	this.additionalServices.amount = null;
		// 	this.additionalServices.paymentFileForm.payment_file = null;
		// 	this.additionalServices.paymentFileForm.error = false;
		// 	this.additionalServices.paymentFileForm.errorMsg = '';
		// },
		cancelAddPaidUsers(item) {
			this.addPaidUsers.showDialog = false;
			this.addPaidUsers.loading = false;
			this.addPaidUsers.amount = null;
			this.addPaidUsers.selectedItem = {};
			this.resetAddPaidUsersForms();
		},
		cancelCreaterefund() {
			this.refund.showDialog = false;
			var form = {
				error: '',
				loading: false,
			}
			Object.assign(this.refund.form, form);
		},
		genericTableRefresh(tableName) {
			if (this.$refs[tableName]) {
				this.$refs[tableName].getItems().then(() => {
				}).catch(err => {
					console.error(err)
				});
			}
		},
		resetModalSendDocsValues() {
			this.modal_send_docs.receiver_user = "";
			this.modal_send_docs.num_docs = "";
			this.modal_send_docs.contract_origin_id = "";
			this.modal_send_docs.max_docs_num = 0;
		},
		cancelSendDocs() {
			this.sendDocsDialog = false;
			this.resetModalSendDocsValues();
		},				
		async confirmSendDocs() {
			this.sendDocsLoading = true;
			const formIsValid = this.$refs.sendDocsDialogForm.validate();
			if (formIsValid) {
				let user_id = this.userData.id;
				let receiver_user_id = this.modal_send_docs.receiver_user;
				let num_docs = this.modal_send_docs.num_docs;
				let contract_origin_id = this.modal_send_docs.contract_origin_id;
				try {
					let response = await new SendDocsUserCommand(sync_command_dispatcher).run(user_id, receiver_user_id, num_docs, contract_origin_id)
					if ('output' in response && response['output'] && 'error' in response['output']) {
						console.error(response['output']['error']);
						this.setSnackbar('error', response['output']['error']);
						this.sendDocsLoading = false;
					}
					else {
						this.sendDocsLoading = false;
						this.sendDocsDialog = false;
						this.resetModalSendDocsValues();
						this.genericTableRefresh('contractsTable');
						this.setSnackbar('success', this.textSnackbarOk);
					}
				} catch (error) {
					console.error(error);
					this.setSnackbar('error', this.textSnackbarKoApi);
					this.sendDocsLoading = false;
				};
			}
			else {
				this.sendDocsLoading = false;
				this.setSnackbar('error', this.textSnackbarKo);
			}
		},

		async confirmUpdateProfileClient() {
			this.profileClientUpdateLoading = true;
			const formIsValid = this.$refs.updateProfileClientForm.validate();
			if (formIsValid) {
				try {
					let user_id = this.userData.id
					let response = await new UpdateFiscalDataUserCommand(sync_command_dispatcher).run(user_id, this.profileClientUpdate.business_name, this.profileClientUpdate.bussnies_id, this.profileClientUpdate.postal_address, this.profileClientUpdate.post_code, this.profileClientUpdate.province)
					if (response.output.status == 'success') {
						this.taxDataSaved = true;
						this.setSnackbar('success', response.output.message);
					} else if (response.output.status == 'error') {
						this.setSnackbar('error', response.output.message);
					} else {
						this.setSnackbar('error', "Error al actualizar los datos fiscales");
					}
				} catch (error) {
					console.error(error);
				}
			}
			this.profileClientUpdateLoading = false;
		},

		isTaxDataFilled(){
			const result = !!(this.profileClientUpdate.business_name && this.profileClientUpdate.bussnies_id && this.profileClientUpdate.postal_address && this.profileClientUpdate.province && this.profileClientUpdate.post_code)
			return result
		},

		isTaxDataFilledAndSaved(){
			return this.isTaxDataFilled() && this.taxDataSaved
		},

		openDialogActivateTrialFacturaeClient() {
			if (this.isTaxDataFilled()) {
				this.showDialogActivateTrialFacturaeClient = true;
			}
			else {
				this.setSnackbar('error', "Debes rellenar los datos fiscales primero y darle a guardar");
			}
		},
		async activateTrialFacturaeClient() {
			if (this.companyActivateTrialClient) {
				try {
					let response = await new ActivateFacturaeClientTrialCommand(sync_command_dispatcher).run(this.companyActivateTrialClient.id)
					console.log("ActivateTrialFacturaeClient")
					if (response && response.hasOwnProperty('output') && response['output']['data'] == 'ok') {
						this.setSnackbar('success', "Contrato trial activado para factura electrónica");
						// Refrescar las tablas de contratos sin recargar toda la página
						if (this.$refs.eInvoiceContractsTable) {
							await this.$refs.eInvoiceContractsTable.getItems();
						}
						if (this.$refs.contractsTable) {
							await this.$refs.contractsTable.getItems();
						}
					}
					else if (response && response.hasOwnProperty('output') && response['output']['error']) {
						this.setSnackbar('error', response['output']['error']);
					}
				}
				catch (error) {
					console.log(error)
					this.setSnackbar('error', error);
				}
				this.showDialogActivateTrialFacturaeClient = false;
			}
			else {
				this.setSnackbar('error', "Debes seleccionar una empresa");
			}
		},
		async is_job_done(job_id) {
			if (job_id) {
				let response = await client.get('jobs/jobs/' + job_id.toString());
				if (response.data.state == 'running') {
					setTimeout(() => this.is_job_done(job_id), 1000);
				} else {
					let errorMsg = "";
					let successMsg = "";
					switch (this.actionModal) {
						case "create_concession":
							errorMsg = "No ha sido posible generar la concesión";
							successMsg = "Concesión generada correctamente";
							this.modal_create_concession.loading = false;
							break;
						case "regenerate_invoice":
							errorMsg = "No ha sido posible generar la factura";
							successMsg = "Factura generada correctamente";
							break;
						case "create_refund":
							errorMsg = response.data.output_info.message;
							successMsg = response.data.output_info.message
							this.refund.showDialog = false;
							break;
						case "regenerate_invoice_with_updated_taxdata":
							errorMsg = response.data.output_info.message;
							successMsg = response.data.output_info.message
							break;
						case "additional_services_upload_payment_file":
							this.additionalServices.showDialog = false;
							this.additionalServices.selectedItem = null;
							this.additionalServices.loading = false;
							this.additionalServices.amount = null;
							this.additionalServices.paymentFileForm.payment_file = null;
							errorMsg = response.data.output_info.message;
							successMsg = response.data.output_info.message
							break;
						case "extend_trial_docs":
							errorMsg = "No ha sido posible modificar los créditos de prueba";
							successMsg = "Créditos de prueba modificados correctamente";
							this.modal_extend_trial_docs.loading = false;
							this.modal_extend_trial_docs.extra_credits = null;
							this.modal_extend_trial_docs.reason = null;
							this.forceRefreshUserData();
							break;
						case "change_end_date":
							this.modal_change_end_date.loading = false;
							this.modal_change_end_date.contract_id = null;
							this.modal_change_end_date.end_date = null;
							this.modal_change_end_date.reason = null;
							this.modal_change_end_date.error = null;
							this.forceRefreshUserData();
							break;
						default:
							break;
					}
					if (response.data.state == 'error' || (response.data.output_info && !response.data.output_info.success)) {
						this.setSnackbar('error', errorMsg);
					} else {
						this.setSnackbar('success', successMsg);
					}
					this.genericTableRefresh(this.sourceTable);
				}
			}
		},
		async APIcreateConcession() {
			try {
				this.modal_create_concession.loading = true;
				let response = await new CreateConcessionCommand(async_command_dispatcher).run(this.modal_create_concession.concession_number, this.modal_create_concession.reason, this.session_information.username)
				this.$set(this.modal_create_concession.selectedItem, 'running_job_id', response.job_id);
				setTimeout(() => this.is_job_done(response.job_id), 1000)
			}
			catch (error) {
				console.log(error)
				this.setSnackbar('error', error);
			}
			this.modal_create_concession.selectedItem = {};
		},

		async APIextendTrialDocs() {
			try {
				this.modal_extend_trial_docs.loading = true;
				const extraCredits = Number(this.modal_extend_trial_docs.extra_credits);
				const contractKind = this.modal_extend_trial_docs.contract_kind;
				let response = await new ExtendTrialDocsCommand(async_command_dispatcher).run(
					extraCredits,
					this.modal_extend_trial_docs.reason,
					this.session_information.username,
					contractKind
				)
				this.$set(this.modal_extend_trial_docs.selectedItem, 'running_job_id', response.job_id);
				// Actualizar localmente el contrato para reflejar el cambio inmediatamente
				this.updateLocalContractLimit(contractKind, extraCredits);
				setTimeout(() => this.is_job_done(response.job_id), 1000)
			}
			catch (error) {
				console.log(error)
				this.setSnackbar('error', error);
			}
			this.modal_extend_trial_docs.selectedItem = {};
			this.modal_extend_trial_docs.loading = false;
		},
		updateLocalContractLimit(contractKind, extraCredits) {
			const contracts = contractKind === 'documents' ? this.userData.contracts : this.userData.all_contracts;
			if (!Array.isArray(contracts)) return;
			const contract = contracts.find(c =>
				c.is_trial === true &&
				c.kind === contractKind &&
				c.is_finished === false
			);
			if (!contract) return;
			if (contractKind === 'documents') {
				this.$set(contract, 'trial_limit', (contract.trial_limit || 25) + extraCredits);
			} else {
				if (!contract.configuration) {
					this.$set(contract, 'configuration', {});
				}
				this.$set(contract.configuration, 'trial_limit', (contract.configuration.trial_limit || 100) + extraCredits);
			}
		},
		set_action_loading(item) {
			if (!item.loading) {
				this.$set(item, 'loading', {});
			}
			this.$set(item.loading, item.action, true);
		},
		async APIregenerateInvoice(item) {
			let repo = new APIServiceDeliveryRepository()
      		try {
				let charge_id = item.charge_id != null ? item.charge_id : item.charge.charge_id;
				this.set_action_loading(item);
				let response = await new RegenerateInvoiceCommand(repo).run(charge_id)
				this.$set(item, 'running_job_id', response.job_id);
				setTimeout(() => this.is_job_done(response.job_id), 1000)
			}
			catch (error) {
				console.log(error)
				this.setSnackbar('error', error);
			}
		},
		async APIcreateRefund(service_delivery_id, charge_id, charge_amount, refund_percentage, product_code) {
			try {
				this.refund.selectedItem.action = "create_refund";
				this.set_action_loading(this.refund.selectedItem);
				let response = await new CreateRefundCommand(async_command_dispatcher).run(service_delivery_id, charge_id, Number(charge_amount), Number(refund_percentage), product_code)
				this.$set(this.refund.selectedItem, 'running_job_id', response.job_id);
				setTimeout(() => this.is_job_done(response.job_id), 1000)
			}
			catch (error) {
				console.log(error)
				this.setSnackbar('error', error);
			}
		},
		async APIRegenerateInvoiceWithUpdatedTaxData(userId, selectedItem, businessData) {
			try {
				let sd_id = selectedItem.id == undefined ? selectedItem.sd_id : selectedItem.id;
				let chargeId = selectedItem.charge_id == undefined ? selectedItem.charge.charge_id : selectedItem.charge_id;
				let chargeAmount = selectedItem.charge_amount == undefined ? selectedItem.charge.amount : selectedItem.charge_amount;
				this.updateUserTaxData.selectedItem.action = "regenerate_invoice_with_updated_taxdata";
				this.set_action_loading(this.updateUserTaxData.selectedItem);
				let response = await new RegenerateInvoiceWithUpdatedTaxDataCommand(async_command_dispatcher).run(
					sd_id, chargeId, chargeAmount,
					businessData.name, businessData.id, businessData.postalAddress, businessData.postCode, businessData.province)
				this.updateUserTaxData.loading = false;
				this.updateUserTaxData.showDialog = false;
				this.$set(this.updateUserTaxData.selectedItem, 'running_job_id', response.job_id);
				setTimeout(() => this.is_job_done(response.job_id), 1000)
			}
			catch (error) {
				console.log(error)
				this.setSnackbar('error', error);
			}
		},
		// async APIAdditionalServiceUploadPaymentFile() {
		// 	this.actionModal = "additional_services_upload_payment_file";
		// 	this.sourceTable = 'additionalServicesTable';
		// 	let item = this.additionalServices.selectedItem
		// 	const formIsValid = this.$refs.form.validate();
		// 	if (formIsValid) {
		// 		this.additionalServices.loading = true;
		// 		this.setupAWSCredentials();
		// 		let response = await new InvoicePaidCustomChargeCommand(async_command_dispatcher, new S3Repository(AWS), this).run(item.charge_id, item.org_id, this.additionalServices.paymentFileForm.payment_file)
		// 		this.$set(this.additionalServices.selectedItem, 'running_job_id', response.job_id);
		// 		await setTimeout(() => this.is_job_done(response.job_id), 1000)
		// 	}
		// },
		// async APIPurchaseExtraUsers() {
		// 	this.actionModal = "purchase_extra_users";
		// 	let item = this.addPaidUsers.selectedItem
		// 	const formIsValid = this.$refs.form.validate();
		// 	if (formIsValid) {
		// 		const sd_id = item.id || item.sd_id;
		// 		this.addPaidUsers.loading = true;
		// 		this.setupAWSCredentials();
		// 		let response = await new PurchaseExtraUsersCommand(async_command_dispatcher, new S3Repository(AWS), this).run(this.userData.id, sd_id, Number(this.addPaidUsers.form.users_num), this.addPaidUsers.paymentFileForm.payment_file, this.addPaidUsers.form.users_num)
		// 		this.$set(this.addPaidUsers.selectedItem, 'running_job_id', response.job_id);
		// 		await setTimeout(() => this.is_job_done(response.job_id), 1000)
		// 	}
		// },
		resetModalSendTransactionsValues() {
			this.modal_send_transactions.receiver_user = "";
			this.modal_send_transactions.num_transactions = "";
			this.modal_send_transactions.contract_origin_id = "";
			this.modal_send_transactions.max_transactions_num = 0;
		},
		cancelSendTransactions() {
			this.sendTransactionsDialog = false;
			this.resetModalSendTransactionsValues();
		},

		async confirmSendTransactions() {
			this.sendTransactionsLoading = true;
			const formIsValid = this.$refs.sendTransactionsDialogForm.validate();
			if (formIsValid) {
				let user_id = this.userData.id;
				let receiver_user_id = this.modal_send_transactions.receiver_user;
				let num_transactions = this.modal_send_transactions.num_transactions;
				let contract_origin_id = this.modal_send_transactions.contract_origin_id;
				try {
					let response = await new SendTransactionsUserCommand(sync_command_dispatcher).run(user_id, receiver_user_id, num_transactions, contract_origin_id)
					if ('output' in response && response['output'] && 'error' in response['output']) {
						console.error(response['output']['error']);
						this.setSnackbar('error', response['output']['error']);
						this.sendTransactionsLoading = false;
					}
					else {
						this.sendTransactionsLoading = false;
						this.sendTransactionsDialog = false;
						this.resetModalSendTransactionsValues();
						this.genericTableRefresh('banksContractsTable');
						this.setSnackbar('success', this.textSnackbarOk);
					}
				} catch (error) {
					console.error(error);
					this.setSnackbar('error', this.textSnackbarKoApi);
					this.sendTransactionsLoading = false;
				};
			}
			else {
				this.sendTransactionsLoading = false;
				this.setSnackbar('error', this.textSnackbarKo);
			}
		},

		assign_promotional_code(code) {
			this.promotional_code = code
		},
		async get_promotional_code() {
			try {
				await new ReferidoPromotionalCodeQuery(query_dispatcher, this).run(this.userData.user)
			} catch (error) {
				console.error('Error get promotional code list', error)
			}
		},
		change_receive_newsletter_loaging_status(value) {
			this.receive_newsletter_loading = value
		},
		async update_receive_newsletter_status() {
			try {
				await new UpdateUserInfo(sync_command_dispatcher, this).run(this.userData.id, this.receive_newsletter)
				this.forceRefreshUserData();
			} catch (error) {
				console.error('Error chnage receive newslatter status', error)
			}
		},
		hasItemsBanksContracts(value) {
			this.hasItemsBanksContractsValue = value;
		},
		hasItemsBanksContractsDTB(value) {
			this.hasItemsBanksContractsDTBValue = value;
		},
		hasItemsInstallations(value) {
			this.hasItemsInstallationsValue = value;
		},
		hasItemsAdditionalServices(value) {
			this.hasItemsAdditionalServicesValue = value;
		},
		hasItemsWorkingHours(value) {
			this.hasItemsWorkingHoursValue = value;
		},
		itemsWorkingHours(value) {
			this.itemsWorkingHoursValue = value.map(item => {
				const processedItem = {
					...item,
					organization_name: (item.companies && item.companies[0] && item.companies[0].name) || null,
					company_id: (item.companies && item.companies[0] && item.companies[0].id) || null
				};
				return processedItem;
			});
		},
		hasItemsWorkingHoursClient(value) {
			this.hasItemsWorkingHoursClientValue = value;
		},
		hasItemsDocsContracts(value) {
			this.hasItemDocsContractsValue = value;
		},
		hasItemsEInvoiceContracts(value) {
			this.hasItemsEInvoiceContractsValue = value;
		},
		hasItemsEInvoiceClientContracts(value) {
			this.hasItemsEInvoiceClientContractsValue = value
		},
		itemsEInvoiceContracts(value) {
			this.itemsEInvoiceContractsValue = value.map(item => {
				const companies = item.companies || [];
				if (companies.length === 0) {
					item.companies_display = '-';
				} else if (companies.length === 1) {
					item.companies_display = companies[0].name;
				} else {
					const allNames = companies.map(c => c.name).join(', ');
					item.companies_display = `<span title="${allNames}">${companies[0].name}...</span>`;
				}
				return item;
			});
		},
		get_available_space() {
			return new GetAvailableSpaceQuery(query_dispatcher, this).run();
		},
		async PaymentInstallation() {
			let install_repo = new APIInstallationsRepository()
			let documentsContracts = await this.$refs.contractsTable.items;
			let banksContracts = await this.$refs.banksContractsTable.items;
			let contracts = [...banksContracts, ...documentsContracts];
			let sds = [];
			for (let i = 0; i < contracts.length; i++) {
				if (!contracts[i].is_finished && !contracts[i].is_done) {
					sds.push(
						new ServiceDelivery(
							contracts[i].sd_id || contracts[i].id,
							this.userData.user,
							contracts[i].name,
							true,
							0,
							[]
						));
				}
			}
			let serviceDeliveryRepo = new MemoryServiceDeliveryRepo(sds, new APICompanyRepository());
			this.setupAWSCredentials();
			const file_repo = new S3Repository(AWS);
			let cmd = new NewInstallationCommand(install_repo, file_repo, this.screen_data_2, serviceDeliveryRepo)
			await cmd.execute(this.userData.user)
			if (this.$refs.installationsTable) {
				this.$refs.installationsTable.getItems().then(() => {
				}).catch(err => {
					console.error(err)
				});
			}
		},

		async close(item, limit) {
			if (this.screen_data_2.selectCompanyPopup.showed) {
				if (limit) {
					await this.screen_data_2.selectCompanyPopup.close(item)
					await this.$refs.eInvoiceContractsTable.getItems().then(() => {
					}).catch(err => {
						console.error(err)
					});
				} else {
					this.setSnackbar('error', 'Se han seleccionado más empresas de las permitidas.');
				}
			} else if (this.screen_data_2.payment_popup.showed) {
				this.screen_data_2.payment_popup.close(item)
			}

		},

		async SelectCompanyToEInvContract(action, item_selected) {
			console.log("SelectCompanyToEInvContract")
			let sdItem = this.itemsEInvoiceContractsValue.find(i => i.sd_id === item.sd_id);
			if (action == 'openPopup'){
				let sd = new ServiceDelivery(
					sdItem.sd_id, // sd_id
					this.userData.user, // user_id
					sdItem.name, // contract_type
					true, // status
					sdItem.total_credits, // credits
					sdItem.companies // companies
				)
				let sd_repo = new APIServiceDeliveryRepository([sd])
				let company_repo = new APICompanyRepository()
				let cmd = new SelectCompaniesSD(this.screen_data_2, company_repo, sd_repo)
				await cmd.execute(sd)
			}
		},
		async openWorkingHoursPopup() {
			console.log("openWorkingHoursPopup")
			// Crear un Service Delivery temporal para poder abrir el popup
			let sd = new ServiceDelivery(
				null, // sd_id
				this.userData.user, // user_id
				'Control Horario', // contract_type
				true, // status
				0, // credits - por ahora 0, luego se actualizará
				[] // companies - vacío por ahora
			)
			let sd_repo = new APIServiceDeliveryRepository([sd])
			let company_repo = new APICompanyRepository()
			let cmd = new SelectCompaniesSD(this.screen_data_2, company_repo, sd_repo)
			await cmd.execute(sd)
		},
		async closeWorkingHoursPopup(item, limit) {
			if (this.screen_data_2.selectWorkingHoursPopup.showed) {
				if (limit) {
					await this.screen_data_2.selectWorkingHoursPopup.close(item)
					await this.$refs.workingHoursClientTable.getItems().then(() => {
					}).catch(err => {
						console.error(err)
					});
				} else {
					this.setSnackbar('error', 'Se han seleccionado más empresas de las permitidas.');
				}
			}
		},
		async openWorkingHoursOwnerPopup(item) {
			// Guardar el service delivery actual
			this.currentServiceDelivery = item;

			// Usar la misma llamada que factura electrónica para obtener las empresas
			let company_repo = new APICompanyRepository();
			const allCompanies = await company_repo.find_by_user_id(this.userData.user);

			// Obtener los IDs de empresas que ya tienen contratos activos de working hours
			const usedCompanyIds = new Set();

			// Iterar sobre los contratos de working hours (itemsWorkingHoursValue tiene los contratos)
			if (this.itemsWorkingHoursValue && Array.isArray(this.itemsWorkingHoursValue)) {
				this.itemsWorkingHoursValue.forEach(contract => {
					// Si el contrato tiene una empresa asignada (company_id no vacío)
					// y no es el contrato actual que estamos editando
					if (contract.company_id && contract.sd_id !== item.sd_id) {
						usedCompanyIds.add(contract.company_id);
					}
				});
			}

			// Filtrar las empresas que ya están siendo usadas
			this.availableCompanies = allCompanies.filter(company => !usedCompanyIds.has(company.id));

			console.log('Empresas disponibles:', this.availableCompanies.length, 'de', allCompanies.length);
			console.log('Empresas ya usadas:', Array.from(usedCompanyIds));

			// Mostrar el popup
			this.showSimpleCompanyPopup = true;
		},
		closeSimpleCompanyPopup() {
			this.showSimpleCompanyPopup = false;
			this.currentServiceDelivery = null;
		},
		async saveSelectedCompany(company) {
			console.log("=== GUARDANDO EMPRESA ===");
			console.log("Company seleccionada:", company);
			console.log("Company ID:", company.id);
			console.log("Company Name:", company.name);
			console.log("Service Delivery ID:", this.currentServiceDelivery.sd_id);

			try {
				// Guardar en el backend
				let sd_repo = new APIServiceDeliveryRepository([]);
				console.log("Llamando a sd_repo.save con sd_id:", this.currentServiceDelivery.sd_id, "y company_ids:", [company.id]);

				const result = await sd_repo.save(this.currentServiceDelivery.sd_id, [company.id]);
				console.log("Resultado del save:", result);

				// Cerrar popup primero
				this.closeSimpleCompanyPopup();

				// Esperar un poco para que el backend procese
				await new Promise(resolve => setTimeout(resolve, 500));

				// Forzar re-render de la tabla cambiando el key
				this.workingHoursTableKey += 1;

				// Esperar al siguiente tick para que Vue re-renderice
				await this.$nextTick();

				console.log("=== TABLA ACTUALIZADA ===");
				this.setSnackbar('success', 'Empresa guardada correctamente');
			} catch (error) {
				console.error("Error al guardar empresa:", error);
				this.setSnackbar('error', 'Error al guardar la empresa');
				this.closeSimpleCompanyPopup();
			}
		},
		async closeWorkingHoursOwnerPopup(item, limit) {
			if (this.screen_data_2.selectWorkingHoursOwnerPopup.showed) {
				if (limit) {
					await this.screen_data_2.selectWorkingHoursOwnerPopup.close(item)
					await this.$refs.workingHoursTable.getItems().then(() => {
					}).catch(err => {
						console.error(err)
					});
				} else {
					this.setSnackbar('error', 'Se han seleccionado más empresas de las permitidas.');
				}
			}
		},
		initProfileClientUpdate() {
			this.profileClientUpdate.business_name = this.profile.form.business_name
			this.profileClientUpdate.bussnies_id = this.profile.form.bussnies_id
			this.profileClientUpdate.postal_address = this.profile.form.postal_address
			this.profileClientUpdate.post_code = this.profile.form.post_code
			this.profileClientUpdate.province = this.profile.form.province
			// Si los datos fiscales ya están completos al cargar, marcarlos como guardados
			this.taxDataSaved = this.isTaxDataFilled()
		},
		set_visibility_CreateConcessionButton() {
			const crearConcessionButtonVisibility = Array.isArray(this.userData.contracts) &&
				this.userData.contracts.some(contract =>
					contract.is_trial === false && contract.name !== "Concesión"
				);
			this.crearConcessionButtonVisibility = crearConcessionButtonVisibility;
		},
		set_visibility_ExtendTrialCreditsButton() {
			// Verificar si hay contratos trial de documentos activos
			this.canExtendDocuments = Array.isArray(this.userData.contracts) &&
				this.userData.contracts.some(contract =>
					contract.is_trial === true &&
					contract.kind === 'documents' &&
					contract.is_finished === false
				);
			// Verificar si hay contratos trial de bancos activos (usar all_contracts que incluye banks)
			this.canExtendBanks = Array.isArray(this.userData.all_contracts) &&
				this.userData.all_contracts.some(contract =>
					contract.is_trial === true &&
					contract.kind === 'banks' &&
					contract.is_finished === false
				);
			// El botón es visible si hay al menos uno de los dos tipos disponible
			this.extendTrialCreditsButtonVisibility = this.canExtendDocuments || this.canExtendBanks;
			// Preseleccionar el tipo disponible
			if (this.canExtendDocuments) {
				this.modal_extend_trial_docs.contract_kind = 'documents';
			} else if (this.canExtendBanks) {
				this.modal_extend_trial_docs.contract_kind = 'banks';
			}
		},
		async get_worker_version() {
			this.worker_version = await new GetOwnerWorkerVersionQuery(query_dispatcher).run()
		},
	},

	async created() {
		this.component = new ProfileAllCommands(this.screen_data, new ApiProfile()) // estaría guapo pasarlo a hexagonal yo dejo la base para que no se vaya volviendo mas grande lo legacy
		await this.component.run()
	},

	async mounted() {
		this.get_promotional_code()
		this.receive_newsletter = this.profile.form.receive_newsletter
		this.get_available_space()
		this.initProfileClientUpdate()
		const crearConcessionButtonVisibility = Array.isArray(this.userData.contracts) &&
			this.userData.contracts.some(contract =>
				contract.is_trial === false && contract.name !== "Concesión"
			);
		this.crearConcessionButtonVisibility = crearConcessionButtonVisibility;
		this.set_visibility_ExtendTrialCreditsButton();
		this.get_worker_version()
	},
}
</script>

<style scoped>
button>.v-btn__content>i {
	background: var(--v-primaryLight-base);
	border-radius: 25px;
	padding: 6px;
	margin-right: 5px;
}

button.btn-profile {
	padding-right: 10px !important;
	padding-left: 10px !important;
	justify-content: start;
}

::v-deep button.btn-profile>span.v-btn__content {
	padding-left: 23px;
	font-size: 16px;
}

.label-card {
	border: 1px solid var(--v-primary-base) !important;
}

.switch_box {
	padding-left: 10px !important;
	border: 1px solid var(--v-primary-base) !important;
	height: 60px;
	display: flex;
	align-items: center;
}

.switch_box:hover {
	background-color: rgba(102, 51, 153, 0.1);
}

.switch {
	margin: 0;
}

.switch__label {
	color: var(--v-primary-base);
	text-transform: none;
	letter-spacing: normal;
	font-weight: bold;
}

.justify-content-center {
	-webkit-box-pack: center !important;
	-ms-flex-pack: center !important;
	justify-content: center !important;
}

.align-items-center {
	align-items: center
}

.small-grey-text {
	font-size: 15px;
	font-weight: normal;
	color: rgb(150, 150, 150);
	text-align: right;
}
.extra-users-modal .total-price{
	color: #7339B7;
	font-size: 16px;
}
.mini-input {
  font-size: 0.875rem;
}
.mini-input ::v-deep .v-input__slot {
  height: 35px !important;
  min-height: 32px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 0.875rem !important;
  line-height: 32px !important;
}
.mini-input ::v-deep input {
  text-align: right;
}
</style>
